import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AccountLayout from "./Account/AccountLayout";
import { t } from "i18next";

const Terms = () => {
  const { type } = useParams();
  const tabList = [
    { label: t("ABOUTUS"), key: "aboutus" },
    { label: t("18Plus"), key: "18" },
    { label: t("PrivacyPolicy"), key: "privacypolicy" },
    { label: t("TermsConditions"), key: "termsandconditions" },
    { label: t("RulesAndRegulations"), key: "rulesandregulations" },
    { label: t("ResponsibleGaming"), key: "responsiblegambling" },
    { label: t("KYC"), key: "kyc" },
  ];

  const [homeTab, setHomeTab] = React.useState(tabList[0]?.key);
  const getTranslateX = (tabKey) => {
    const index = tabList.findIndex((tab) => tab.key === tabKey);
    return index === -1 ? 0 : index * -100;
  };
  useEffect(() => {
    if (
      [
        "aboutus",
        "18",
        "privacypolicy",
        "termsandconditions",
        "rulesandregulations",
        "responsiblegambling",
        "kyc",
      ].includes(type)
    ) {
      setHomeTab(type);
    } else {
      setHomeTab(tabList[0]?.key);
    }
  }, [type]);
  return (
    <AccountLayout title={t("TC")}>
      <div _ngcontent-serverapp-c3368753927 className="tnc-wrapper">
        <div
          _ngcontent-serverapp-c3368753927
          className="search-tab-wrapper ng-star-inserted"
        >
          <div _ngcontent-serverapp-c3368753927 className="tab search-tab">
            <ul _ngcontent-serverapp-c3368753927>
              {tabList.map((tab) => (
                <li
                  key={tab?.key}
                  className={`ng-star-inserted ${homeTab === tab?.key ? "active" : ""}`}
                  onClick={() => setHomeTab(tab?.key)}
                >
                  <label _ngcontent-serverapp-c3368753927>{tab?.label}</label>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div
          _ngcontent-serverapp-c3368753927
          className="content-box-wrapper ng-star-inserted"
          style={{
            "-webkit-transform": `translate(${getTranslateX(homeTab)}%, 0px)`,
            "-ms-transform": `translate(${getTranslateX(homeTab)}%, 0px)`,
            transform: `translate(${getTranslateX(homeTab)}%, 0px)`,
            transition: "transform 0.4s ease-in-out",
          }}
        >
          <div
            _ngcontent-serverapp-c3368753927
            className="content-box ng-star-inserted"
          >
            <div _ngcontent-serverapp-c3368753927 className="title">
              {t("ABOUTUS")}
            </div>
            <div _ngcontent-serverapp-c3368753927>
              <p>
                <b>
                  <span>About Us</span>
                </b>
              </p>
              <h4 dir="ltr">
                <b>
                  <span>About bajifair</span>
                </b>
              </h4>
              <p dir="ltr">
                <b>
                  <span>
                    bajifair is a top-notch online gambling brand in Asia. We
                    provide the most competitive odds on hundreds of markets
                    across major sports, like cricket, football, basketball,
                    tennis, and other popular sports! In addition, we also offer
                    varieties of exciting online gaming products, including
                    slots, live casino, poker, and more!
                  </span>
                  <br />
                  <br />
                  <span>
                    At bajifair, we are committed to create a safe, stable, fair
                    and reliable gambling environment for our players to enjoy
                    the supreme gaming experience.
                  </span>
                  <br />
                  <br />
                  <span>Safe &amp; Private Environment</span>
                  <br />
                  <span>
                    bajifair cooperates with the world’s top network security
                    and uses the highest quality security system together with a
                    128-bit encryption to ensure all your transactions as well
                    as privacy of your data are safe and secure. We promise to
                    keep all of your information strictly confidential and
                    private, and will never be sold to any third parties, except
                    in accordance with our Privacy Policy.
                  </span>
                  <br />
                  <br />
                  <span>Customer Support</span>
                  <br />
                  <span>
                    Our highly trained customer support team available 24 hours
                    a day, 7 days a week, offering efficient and dedicated
                    support to help answer your queries and assist with any of
                    your issues.
                  </span>
                </b>
                <br />
                <br />
                <br />
                &nbsp;
              </p>
            </div>
          </div>

          <div
            _ngcontent-serverapp-c3368753927
            className="content-box ng-star-inserted"
          >
            <div _ngcontent-serverapp-c3368753927 className="title">
              {t("18Plus")}
            </div>
            <div _ngcontent-serverapp-c3368753927>
              <p>
                <b>
                  <span>18+</span>
                </b>
              </p>
              <h4 dir="ltr">
                <b>
                  <span>Only for customers aged 18 and above</span>
                </b>
              </h4>
              <p dir="ltr">
                <b>
                  <span>
                    bajifair is only made available to customers aged 18 and
                    above only. The act of a customer under the age of 18
                    opening an account and/or gambling on bajifair is considered
                    as an offence. bajifair carries out age-verifications and
                    reserves the right to carry out such verifications at our
                    own discretion. The company has responsibilities to carry
                    out age verifications and we take it very seriously.
                    Customers that have been requested to complete age
                    verifications will not be able to use any of our payment
                    services until the age verification is complete. bajifair
                    reserves the rights to suspend your account while pending
                    for your age verification.
                  </span>
                  <br />
                  <br />
                  <span>
                    Note: IF ANY CUSTOMERS BELOW 18 YEARS OF AGE ARE FOUND USING
                    bajifair, THE COMPANY RESERVES THE RIGHTS TO FORFEIT ALL
                    WINNINGS AND REPORT IT TO THE RELEVANT AUTHORITIES.
                  </span>
                  <br />
                  <br />
                  <span>Filtering Systems</span>
                  <br />
                  <span>
                    bajifair strongly encourages and advises all its customers
                    to ensure that minors would not access any e-gaming
                    websites.
                  </span>
                  <br />
                  <br />
                  <span>
                    Parents can regulate internet access with filtering
                    solutions based on selected criteria. With filtering
                    solutions, parents can regulate internet access and prevent
                    minors from accessing e-gaming websites. Filtering solutions
                    can deny access to bajifair after detecting the content on
                    our site and the solutions can achieve that because we label
                    our website. If your device is shared among family and
                    friends who are minors, please consider using parental
                    filtering solutions to deny them access to bajifair.
                  </span>
                </b>
                <br />
                <br />
                <br />
                &nbsp;
              </p>
            </div>
          </div>

          <div
            _ngcontent-serverapp-c3368753927
            className="content-box ng-star-inserted"
          >
            <div _ngcontent-serverapp-c3368753927 className="title">
              {t("PrivacyPolicy")}
            </div>
            <div _ngcontent-serverapp-c3368753927>
              <p>
                <b>
                  <span>Privacy Policy</span>
                </b>
              </p>
              <p dir="ltr">
                <b>
                  <span>
                    Your privacy is important to us, and we are committed to
                    protecting your personal information. We will be clear and
                    open about why we collect your personal information and how
                    we use it. Where you have choices or rights, we will explain
                    these to you.
                  </span>
                  <br />
                  <br />
                  <span>
                    This Privacy Policy explains how bajifair uses your personal
                    information when you are using one of our website.
                  </span>
                  <br />
                  <br />
                  <span>
                    If you do not agree with any statements contained within
                    this Privacy Policy, please do not proceed any further on
                    our website. Please be aware that registering an account on
                    our website, placing bets and transferring funds will be
                    deemed confirmation of your full agreement with our Terms
                    and Conditions and our Privacy Policy. You have the right to
                    cease using the website at any time; however, we may still
                    be legally required to retain some of your personal
                    information.
                  </span>
                  <br />
                  <br />
                  <span>
                    We may periodically make changes to this Privacy Policy and
                    will notify you of these changes by posting the modified
                    terms on our platforms. We recommend that you revisit this
                    Privacy Policy regularly
                  </span>
                  <br />
                  <br />
                  <span>Who is in control of your information?</span>
                  <br />
                  <span>
                    Throughout this Privacy Policy, bajifair together with our
                    subsidiaries and affiliates (collectively, “we” or “us” or
                    “our”) control the ways your Personal Data is collected and
                    the purposes for which your Personal Data is used by
                    bajifair, acting as the “data controller” for the purposes
                    of applicable European data protection legislation.
                  </span>
                </b>
                <br />
                <br />
                <b>
                  <span>Our Data Protection Officer</span>
                </b>
                <br />
                <b>
                  <span>
                    If you have concerns or would like any further information
                    about how bajifair handles your personal information, you
                    can contact our Data Protection Officer at{" "}
                  </span>
                  <a href="mailto:info@bajifair.live">
                    <span>info@bajifair.live</span>
                  </a>
                  <span>.</span>
                  <br />
                  <br />
                  <span>Information we collect about you</span>
                  <br />
                  <span>Personally identifiable information</span>
                  <br />
                  <span>
                    You provide this information to us in the process of setting
                    up an account, placing bets and using the services of the
                    website. This information is required to give you access to
                    certain parts of our website and related services. This data
                    is collected when you:
                  </span>
                  <br />
                  <br />
                  <span>* Register an account with bajifair;</span>
                  <br />
                  <br />
                  <span>* Voluntarily provide it when using the website;</span>
                  <br />
                  <br />
                  <span>
                    * Personally disclose the information in public areas of the
                    website; and
                  </span>
                  <br />
                  <br />
                  <span>
                    * Provide it when you contact our customer support team
                  </span>
                  <br />
                  <br />
                  <span>The information includes your:</span>
                  <br />
                  <br />
                  <span>* Username;</span>
                  <br />
                  <br />
                  <span>* First and surname;</span>
                  <br />
                  <br />
                  <span>* Email address;</span>
                  <br />
                  <br />
                  <span>* Residential address;</span>
                  <br />
                  <br />
                  <span>* Phone number;</span>
                  <br />
                  <br />
                  <span>* Billing address;</span>
                  <br />
                  <br />
                  <span>* Identification documents;</span>
                  <br />
                  <br />
                  <span>* Proof of address documents;</span>
                  <br />
                  <br />
                  <span>* Transaction history;</span>
                  <br />
                  <br />
                  <span>* Website usage preferences;</span>
                  <br />
                  <br />
                  <span>
                    * Any other information you provide us when using our
                    platforms; and
                  </span>
                  <br />
                  <br />
                  <span>
                    * Credit/debit card details, or other payment information
                  </span>
                  <br />
                  <br />
                  <span>
                    The information is also required for billing purposes and
                    for the protection of minors. You can amend and update this
                    information by contacting Customer Support. This data is for
                    internal use only and is never passed to any third parties
                    except those stated below.
                  </span>
                  <br />
                  <br />
                  <span>Telephone Calls</span>
                  <br />
                  <span>
                    Telephone calls to and from our Customer Contact Centre are
                    recorded for training and security purposes along with the
                    resolution of any queries arising from the service you
                    received.
                  </span>
                  <br />
                  <br />
                  <span>Social Features of Our Products</span>
                  <br />
                  <span>
                    If you choose to participate in any of the social features
                    that we provide with our products (such as chat rooms),
                    bajifair may store records or otherwise process this data.
                  </span>
                  <br />
                  <br />
                  <span>
                    Non-personally identifiable information and traffic analysis
                  </span>
                  <br />
                  <span>
                    bajifair strives to make our website as user friendly as
                    possible and easy to find on the Internet. bajifair collects
                    data on how you use the site, which does not identify you
                    personally. When you interact with the services, our servers
                    keep an activity log unique to you that collects certain
                    administrative and traffic information including: source IP
                    address, time of access, date of access, web page(s)
                    visited, language use, software crash reports and type of
                    browser used. This information is essential for the
                    provision and quality of our services.
                  </span>
                  <br />
                  <br />
                  <span>Cookies</span>
                  <br />
                  <span>
                    bajifair uses cookies to ensure our website works
                    efficiently and to enhance your visits to our platforms.
                    Further information can be found in our Cookie Policy.
                  </span>
                  <br />
                  <br />
                  <span>How and why we use your personal information</span>
                  <br />
                  <span>
                    We use your personal information in a range of ways that
                    fall into the following categories:
                  </span>
                  <br />
                  <br />
                  <span>
                    * To provide you with the products or services you have
                    requested;
                  </span>
                  <br />
                  <br />
                  <span>* To meet our legal or regulatory obligations;</span>
                  <br />
                  <br />
                  <span>* To monitor our website performance; and</span>
                  <br />
                  <br />
                  <span>* To provide you with marketing information</span>
                  <br />
                  <br />
                  <span>
                    Your rights over your personal information differ according
                    to which category and lawful basis this fall into. This
                    section provides more information about each category, the
                    rights it gives you, and how to exercise these rights. These
                    rights are in bold following each category.
                  </span>
                  <br />
                  <br />
                  <span>Providing our products and services</span>
                  <br />
                  <span>
                    We use your personal information to enable you to use our
                    websites, to set up your account, participate in the online
                    sports book, casino and to provide you with customer service
                    assistance.
                  </span>
                  <br />
                  <br />
                  <span>
                    To provide our products and services, we share your
                    information with external organisations working on our
                    behalf. Further information can be found in the Sharing
                    Information section.
                  </span>
                  <br />
                  <br />
                  <span>
                    This category covers the essential activities required in
                    order for us to provide you with the services you use or
                    have signed up for. If you don’t want your information used
                    in this way, your option is to not use our services and
                    close your account..
                  </span>
                  <br />
                  <br />
                  <span>
                    bajifair will use your identification document and/or proof
                    of address to check your details in order for us to protect
                    our users from fraudulent behaviour and to promote
                    responsible gambling.
                  </span>
                  <br />
                  <br />
                  <span>
                    We may conduct a security review at any time to validate the
                    registration data provided by you and to verify your use of
                    the services and your financial transactions for potential
                    breach of our Terms and Conditions and of applicable law.
                    Security reviews may include but are not limited to ordering
                    a credit report and/or otherwise verifying the information
                    you provide against third-party databases.
                  </span>
                  <br />
                  <br />
                  <span>To monitor our website performance</span>
                  <br />
                  <span>
                    As detailed above, we use cookies and traffic analysis in
                    order to improve the performance of our website and services
                    available. We have a legitimate interest in carrying out
                    these activities and we ensure that we minimise any impact
                    on your privacy.
                  </span>
                  <br />
                  <br />
                  <span>
                    You have the ‘right to object’ to activities carried out for
                    our legitimate interest if you believe your right to privacy
                    outweighs our legitimate business interests. However, as the
                    activities involved are central to our business, if you wish
                    to object further than managing your cookies this may mean
                    you need to close your account.
                  </span>
                  <br />
                  <br />
                  <span>Marketing</span>
                  <br />
                  <span>
                    If you have given us your consent to do so, we will send you
                    offers and
                  </span>
                  <br />
                  <span>
                    promotions via email, SMS or online. We do not share your
                    information with third parties for them to use for their own
                    marketing.
                  </span>
                  <br />
                  <br />
                  <span>
                    You have the right to withdraw consent or update your
                    marketing preferences at any time.
                  </span>
                  <br />
                  <br />
                  <span>Your rights</span>
                  <br />
                  <span>Your rights to rectification</span>
                  <br />
                  <span>
                    If you believe the personal information we hold on you is
                    incorrect, you have the right for this to be rectified. For
                    any information that cannot be updated through My Account,
                    please contact{" "}
                  </span>
                  <a href="mailto:info@bajifair.live">
                    <span>info@bajifair.live</span>
                  </a>
                  <span>.</span>
                  <br />
                  <br />
                  <span>
                    Your right to request a copy of your personal information
                  </span>
                  <br />
                  <span>
                    If you would like a copy of the personal information we hold
                    about you, you should request it through live chat or by
                    emailing info@bajifair.live and we will provide you with a
                    form to complete. The form is not compulsory but helps us to
                    provide you with the information you are looking for in a
                    timely manner. To ensure the security of your personal
                    information, we will ask you for valid proof of identity and
                    once we’ve received it we will provide our response within
                    one month. If your request is unusually complex and likely
                    to take longer than a month, we will let you know as soon as
                    we can and tell you how long we think it will take, such
                    request may also incur an administration cost.
                  </span>
                  <br />
                  <br />
                  <span>Your right of erasure</span>
                  <br />
                  <span>
                    You can request us to erase your personal data where there
                    is no compelling reason to continue processing. This right
                    only applies in certain circumstances; it is not a
                    guaranteed or absolute right.
                  </span>
                  <br />
                  <span>
                    The right to erasure does not apply if processing is
                    necessary for one of the following reasons: to exercise the
                    right of freedom of expression and information; to comply
                    with a legal obligation; for the performance of a task
                    carried out in the public interest or in the exercise of
                    official authority; for archiving purposes in the public
                    interest, scientific research historical research or
                    statistical purposes where erasure is likely to render
                    impossible or seriously impair the achievement of that
                    processing; or *for the establishment, exercise or defence
                    of legal claims.
                  </span>
                  <br />
                  <br />
                  <span>Sharing your personal information</span>
                  <br />
                  <span>
                    We may disclose your Personal Data to third parties:
                  </span>
                  <br />
                  <br />
                  <span>
                    * If we are under a duty to disclose or share your personal
                    information in order to comply with any legal or regulatory
                    obligation;
                  </span>
                  <br />
                  <br />
                  <span>
                    * In order to enforce or apply the terms of this notice or
                    any other agreements;
                  </span>
                  <br />
                  <br />
                  <span>
                    * To assist us in providing you with the products and
                    services you request, including but not limited to third
                    party software providers;
                  </span>
                  <br />
                  <br />
                  <span>
                    * If, in our sole determination, you are found to have
                    cheated or attempted to defraud us, or other users of the
                    service in any way including but not limited to game
                    manipulation or payment fraud;
                  </span>
                  <br />
                  <br />
                  <span>
                    *For the purpose of research on the prevention of addiction
                    (this data will be made anonymous)
                  </span>
                  <br />
                  <br />
                  <span>
                    * To protect the rights, property or safety of us, our
                    customers or others; and
                  </span>
                  <br />
                  <br />
                  <span>
                    * Where we have received your permission for us to do so.
                  </span>
                  <br />
                  <br />
                  <span>
                    Personal Information collected on the services may be stored
                    and processed in any country in which we or our affiliates,
                    suppliers or agents maintain facilities. By using our
                    services, you expressly consent to any transfer of
                    information outside of your country. When we transfer any
                    part of your Personal Data outside the EEA or adequate
                    jurisdictions we will take reasonable steps to ensure that
                    it is treated as securely as it is within the EEA or
                    adequate jurisdictions. These steps include but are not
                    limited to the following:
                  </span>
                  <br />
                  <br />
                  <span>* Binding corporate rules;</span>
                  <br />
                  <br />
                  <span>* Model contracts; or</span>
                  <br />
                  <br />
                  <span>* US/EU privacy shield</span>
                  <br />
                  <br />
                  <span>Security</span>
                  <br />
                  <span>
                    We understand the importance of security and the techniques
                    needed to secure information. We store all of the Personal
                    Information we receive directly from you in an encrypted and
                    password protected database residing within our secure
                    network behind active state-of-the-art firewall software.
                    (Our Services support SSL Version 3 with 128-bit
                    encryption). We also take measures to ensure our
                    subsidiaries, agents, affiliates and suppliers employ
                    adequate security measures.
                  </span>
                  <br />
                  <br />
                  <span>Retention</span>
                  <br />
                  <span>
                    We retain personal information for as long as we reasonably
                    require it for legal
                  </span>
                  <br />
                  <span>
                    or business purposes. In determining data retention periods,
                    bajifair takes into consideration local laws, contractual
                    obligations, and the expectations and requirements of our
                    customers. When we no longer need your personal information,
                    we securely delete or destroy it.
                  </span>
                  <br />
                  <br />
                  <span>Third-Party Practices</span>
                  <br />
                  <span>
                    We cannot ensure the protection of any information that you
                    provide to a third-party online site that links to or from
                    the services or any information collected by any third party
                    administering our affiliate program (if applicable) or any
                    other program, since these third-party online sites are
                    owned and operated independently from us. Any information
                    collected by these third parties is governed by the privacy
                    policy, if any, of such third party.
                  </span>
                  <br />
                  <br />
                  <span>
                    Our web site may contain links to other web sites, which are
                    outside our control and are not covered by this Privacy
                    Policy. If you access other sites using the links provided,
                    the operators of these sites may collect information from
                    you which will be used by them in accordance with their
                    privacy policy, which may differ from ours. We are not
                    responsible solely the operators of these websites shall be
                    responsible for their functionality or possible errors on
                    the linked sites.
                  </span>
                  <br />
                  <br />
                  <span>Analytics</span>
                  <br />
                  <span>Google Analytics (Google Inc.)</span>
                  <br />
                  <span>
                    Google Analytics is a web analysis service provided by
                    Google Inc. (“Google”). Google utilizes the Data collected
                    to track and examine the use of bajifair, to prepare reports
                    on its activities and share them with other Google services.
                  </span>
                </b>
                <br />
                <br />
                <b>
                  <span>
                    Google may use the Data collected to contextualize and
                    personalize the ads of its own advertising network.
                  </span>
                  <br />
                  <br />
                  <span>Personal Data collected: Cookies and Usage Data</span>
                  <br />
                  <br />
                  <span>Disclaimer</span>
                  <br />
                  <span>
                    The Services operate ‘AS-IS’ and ‘AS-AVAILABLE’ without
                    liability of any kind. We are not responsible for events
                    beyond our direct control. Due to the complex and
                    ever-changing nature of our technology and business, we
                    cannot guarantee, nor do we claim that there will be
                    error-free performance regarding the privacy of your
                    Personal Information, and we will not be liable for any
                    indirect, incidental, consequential or punitive damages
                    relating to the use or release of said Personal Information.
                  </span>
                </b>
                <br />
                <br />
                <br />
                <b>
                  <span>Changes to our Privacy Statement</span>
                </b>
                <br />
                <b>
                  <span>
                    We may update this policy from time to time, so please
                    review it frequently.
                  </span>
                  <br />
                  <br />
                  <span>
                    If any material changes are made to this Privacy Policy we
                    will use reasonable endeavours to inform you in advance by
                    email, notice on the Website or other agreed communications
                    channels. We will communicate the changes to you in advance,
                    giving an appropriate amount of time for you to consider and
                    understand the changes before they become effective.
                  </span>
                  <br />
                  <br />
                  <span>
                    We will not enforce material changes to the Privacy Policy
                    without your express consent. If you decline to accept the
                    changes to the Privacy Policy, or otherwise
                  </span>
                  <br />
                  <span>
                    do not accept the changes within the time period, we may not
                    be able to continue to provide some or all products and
                    services.
                  </span>
                </b>
                <br />
                <br />
                <br />
                &nbsp;
              </p>
            </div>
          </div>

          <div
            _ngcontent-serverapp-c3368753927
            className="content-box ng-star-inserted"
          >
            <div _ngcontent-serverapp-c3368753927 className="title">
              {t("TermsConditions")}
            </div>
            <div _ngcontent-serverapp-c3368753927>
              <p>
                <b>
                  <span>Terms &amp; Conditions</span>
                </b>
                <br />
                <br />
                <br />
                <b>
                  <span>1. Introduction</span>
                  <br />
                  <span>
                    These terms and conditions and the documents referred to
                    below (the "Terms") apply to the use of the current website
                    (the "Website") and its related or connected services
                    (collectively, the "Service").
                  </span>
                  <br />
                  <br />
                  <span>
                    You should carefully review these Terms as they contain
                    important information concerning your rights and obligations
                    concerning the use of the Website and form a binding legal
                    agreement between you - our customer (the "Customer"), and
                    us. By using this Website and/or accessing the Service, you,
                    whether you are a guest or a registered user with an account
                    (“Account”), agree to be bound by these Terms, together with
                    any amendments, which may be published from time to time. If
                    you do not accept these Terms, you should refrain from
                    accessing the Service and using the Website.
                  </span>
                </b>
              </p>
              <p dir="ltr">
                <b>
                  <span>
                    The Service is owned by Aurora Holdings N.V., a limited
                    liability company registered in Curacao with company
                    registration number 10692, with registered address at
                    Abraham de Veerstraat 9, Willemstad, Curacao (“Company”),
                    licensed in Curaçao under Gaming Services Provider N.V.
                    license # 365/JAZ for the provision of online games of
                    chance.
                  </span>
                  <br />
                  <br />
                  <br />
                  <span>2. General Terms</span>
                  <br />
                  <span>
                    We reserve the right to revise and amend the Terms
                    (including any documents referred to and linked to below) at
                    any time. You should visit this page periodically to review
                    the Terms and Conditions. Amendments will be binding and
                    effective immediately upon publication on this Website. If
                    you object to any such changes, you must immediately stop
                    using the Service. Your continued use of the Website
                    following such publication will indicate your agreement to
                    be bound by the Terms as amended. Any bets not settled prior
                    to the changed Terms taking effect will be subject to the
                    pre-existing Terms.
                  </span>
                  <br />
                  <br />
                  <br />
                  <span>3. Your Obligations</span>
                  <br />
                  <span>
                    You acknowledge that at all times when accessing the Website
                    and using the Service:
                  </span>
                  <br />
                  <br />
                  <span>
                    3.1. You are over 18, or the legal age at which gambling, or
                    gaming activities are allowed under the law or jurisdiction
                    that applies to you. We reserve the right to request proof
                    of age documents from you at any time.
                  </span>
                  <br />
                  <br />
                  <span>
                    3.2. You are of legal capacity and can enter into a binding
                    legal agreement with us. You must not access the Website or
                    utilize the Service if you are not of legal capacity.
                  </span>
                  <br />
                  <br />
                  <span>
                    3.3. You are a resident in a jurisdiction that allows
                    gambling. You are not a resident of any country in which
                    access to online gambling to its residents or to any person
                    within such country is prohibited. It is your sole
                    responsibility to ensure that your use of the service is
                    legal.
                  </span>
                  <br />
                  <br />
                  <span>
                    3.4. You may not use a VPN, proxy or similar services or
                    devices that mask or manipulate the identification of your
                    real location.
                  </span>
                  <br />
                  <br />
                  <span>
                    3.5. You are the authorized user of the payment method you
                    use.
                  </span>
                  <br />
                  <br />
                  <span>
                    3.6. You must make all payments to us in good faith and not
                    attempt to reverse a payment made or take any action which
                    will cause such payment to be reversed by a third party.
                  </span>
                  <br />
                  <br />
                  <span>
                    3.7. When placing bets you may lose some or all of your
                    money deposited to the Service in accordance with these
                    Terms and you will be fully responsible for that loss.
                  </span>
                  <br />
                  <br />
                  <span>
                    3.8. When placing bets you must not use any information
                    obtained in breach of any legislation in force in the
                    country in which you were when the bet was placed.
                  </span>
                  <br />
                  <br />
                  <span>
                    3.9. You are not acting on behalf of another party or for
                    any commercial purposes, but solely on your own behalf as a
                    private individual in a personal capacity.
                  </span>
                  <br />
                  <br />
                  <span>
                    3.10. You must not either attempt to manipulate any market
                    or element within the Service in bad faith nor in a manner
                    that adversely affects the integrity of the Service or us.
                  </span>
                  <br />
                  <br />
                  <span>
                    3.11. You must generally act in good faith in relation to us
                    of the Service at all times and for all bets made using the
                    Service.
                  </span>
                  <br />
                  <br />
                  <span>
                    3.12. You, or, if applicable, your employees, employers,
                    agents, or family members, are not registered as an
                    Affiliate in our Affiliate program.
                  </span>
                  <br />
                  <br />
                  <br />
                  <span>4. Restricted Use</span>
                  <br />
                  <span>4.1. You must not use the Service:</span>
                  <br />
                  <br />
                  <span>
                    4.1.1. If you are under the age of 18 years (or below the
                    age of majority as stipulated in the laws of the
                    jurisdiction applicable to you) or if you are not legally
                    able to enter into a binding legal agreement with us or you
                    acting as an agent for, or otherwise on behalf, of a person
                    under 18 years (or below the age of majority as stipulated
                    in the laws of the jurisdiction applicable to you);
                  </span>
                  <br />
                  <br />
                  <span>
                    4.1.2. If you reside in a country in which access to online
                    gambling to its residents or to any person within such
                    country is prohibited.
                  </span>
                  <br />
                  <br />
                  <span>
                    4.1.3. If you are a resident of one of the following
                    countries, or accessing the Website from one of the
                    following countries:
                  </span>
                  <br />
                  <br />
                  <span>* Austria</span>
                  <br />
                  <br />
                  <span>* Australia</span>
                  <br />
                  <br />
                  <span>* Aruba</span>
                  <br />
                  <br />
                  <span>* Bonaire</span>
                  <br />
                  <br />
                  <span>* Curacao</span>
                  <br />
                  <br />
                  <span>* France</span>
                  <br />
                  <br />
                  <span>* Netherlands</span>
                  <br />
                  <br />
                  <span>* Saba</span>
                  <br />
                  <br />
                  <span>* Statia</span>
                  <br />
                  <br />
                  <span>* St. Maarten</span>
                  <br />
                  <br />
                  <span>* Singapore</span>
                  <br />
                  <br />
                  <span>* Spain</span>
                  <br />
                  <br />
                  <span>* The United Kingdom</span>
                  <br />
                  <br />
                  <span>* United States</span>
                  <br />
                  <br />
                  <span>
                    * And any other jurisdiction that the Central Government of
                    Curacao deems online gambling illegal. Including all the
                    named Nation’s territories and possessions
                  </span>
                  <br />
                  <br />
                  <span>
                    4.1.4. To collect nicknames, e-mail addresses and/or other
                    information of other Customers by any means (for example, by
                    sending spam, other types of unsolicited emails or the
                    unauthorised framing of, or linking to, the Service);
                  </span>
                  <br />
                  <br />
                  <span>
                    4.1.5. to disrupt or unduly affect or influence the
                    activities of other Customers or the operation of the
                    Service generally;
                  </span>
                  <br />
                  <br />
                  <span>
                    4.1.6. to promote unsolicited commercial advertisements,
                    affiliate links, and other forms of solicitation which may
                    be removed from the Service without notice;
                  </span>
                  <br />
                  <br />
                  <span>
                    4.1.7. in any way which, in our reasonable opinion, could be
                    considered as an attempt to: (i) cheat the Service or
                    another Customer using the Service; or (ii) collude with any
                    other Customer using the Service in order to obtain a
                    dishonest advantage;
                  </span>
                  <br />
                  <br />
                  <span>
                    4.1.8. to scrape our odds or violate any of our Intellectual
                    Property Rights; or
                  </span>
                  <br />
                  <br />
                  <span>4.1.9. for any unlawful activity whatsoever.</span>
                  <br />
                  <br />
                  <span>
                    4.2. You cannot sell or transfer your account to third
                    parties, nor can you acquire a player account from a third
                    party.
                  </span>
                  <br />
                  <br />
                  <span>
                    4.3. You may not, in any manner, transfer funds between
                    player accounts.
                  </span>
                  <br />
                  <br />
                  <span>
                    4.4. We may immediately terminate your Account upon written
                    notice to you if you use the Service for unauthorised
                    purposes. We may also take legal action against you for
                    doing so in certain circumstances.
                  </span>
                  <br />
                  <br />
                  <span>
                    4.5. Employees of Company, its licensees, distributors,
                    wholesalers, subsidiaries, advertising, promotional or other
                    agencies, media partners, contractors, retailers and members
                    of the immediate families of each are NOT allowed to use the
                    Service for real money without prior consent from the
                    Company Director or CEO. Should such activity be discovered,
                    the account(s) will be immediately terminated and all
                    bonuses/winnings will be forfeited.
                  </span>
                  <br />
                  <br />
                  <br />
                  <span>5. Registration</span>
                  <br />
                  <span>
                    You agree that at all times when using the Service:
                  </span>
                  <br />
                  <br />
                  <span>
                    5.1. We reserve the right to refuse to accept a registration
                    application from any applicant at our sole discretion and
                    without any obligation to communicate a specific reason.
                  </span>
                  <br />
                  <br />
                  <span>
                    5.2. Before using the Service, you must personally complete
                    the registration form and read and accept these Terms. In
                    order to start betting on the Service or withdraw your
                    winnings, we may require you to become a verified Customer
                    which includes passing certain checks. You may be required
                    to provide a valid proof of identification and any other
                    document as it may be deemed necessary. This includes but is
                    not limited to, a picture ID (copy of passport, driver's
                    licence or national ID card) and a recent utility bill
                    listing your name and address as proof of residence. We
                    reserve the right to suspend wagering or restrict Account
                    options on any Account until the required information is
                    received. This procedure is done in accordance with the
                    applicable gaming regulation and the anti-money laundering
                    legal requirements. Additionally, you will need to fund your
                    Service Account using the payment methods set out on the
                    payment section of our Website.
                  </span>
                  <br />
                  <br />
                  <span>
                    5.3. You have to provide accurate contact information,
                    inclusive of a valid email address (“Registered Email
                    Address”), and update such information in the future to keep
                    it accurate. It is your responsibility to keep your contact
                    details up to date on your Account. Failure to do so may
                    result in you failing to receive important Account related
                    notifications and information from us, including changes we
                    make to these Terms. We identify and communicate with our
                    Customers via their Registered Email Address. It is the
                    responsibility of the Customer to maintain an active and
                    unique email account, to provide us with the correct email
                    address and to advise Company of any changes in their email
                    address. Each Customer is wholly responsible for maintaining
                    the security of his Registered Email Address to prevent the
                    use of his Registered Email Address by any third party.
                    Company shall not be responsible for any damages or losses
                    deemed or alleged to have resulted from communications
                    between Company and the Customer using the Registered Email
                    Address. Any Customer not having an email address reachable
                    by Company will have his Account suspended until such an
                    address is provided to us. We will immediately suspend your
                    Account upon written notice to you to this effect if you
                    intentionally provide false or inaccurate personal
                    information. We may also take legal action against you for
                    doing so in certain circumstances and/or contact the
                    relevant authorities who may also take action against you.
                  </span>
                  <br />
                  <br />
                  <span>
                    5.4. You are only allowed to register one Account with the
                    Service. Accounts are subject to immediate closure if it is
                    found that you have multiple Accounts registered with us.
                    This includes the use of representatives, relatives,
                    associates, affiliates, related parties, connected persons
                    and/or third parties operating on your behalf.
                  </span>
                  <br />
                  <br />
                  <span>
                    5.5. In order to ensure your financial worthiness and to
                    confirm your identity, we may ask you to provide us with
                    additional personal information, such as your name and
                    surname, or use any third-party information providers we
                    consider necessary. Should any additional personal
                    information be obtained via third-party sources, we will
                    inform you about the data obtained.
                  </span>
                  <br />
                  <br />
                  <span>
                    5.6. You must keep your password for the Service
                    confidential. Provided that the Account information
                    requested has been correctly supplied, we are entitled to
                    assume that bets, deposits and withdrawals have been made by
                    you. We advise you to change your password on a regular
                    basis and never disclose it to any third party. It is your
                    responsibility to protect your password and any failure to
                    do so shall be at your sole risk and expense. You may log
                    out of the Service at the end of each session. If you
                    believe any of your Account information is being misused by
                    a third party, or your Account has been hacked into, or your
                    password has been discovered by a third party, you must
                    notify us immediately. You must notify us if your Registered
                    Email Address has been hacked into, we may, however, require
                    you to provide additional information/ documentation so that
                    we can verify your identity. We will immediately suspend
                    your Account once we are aware of such an incident. In the
                    meantime you are responsible for all activity on your
                    Account including third party access, regardless of whether
                    or not their access was authorised by you.
                  </span>
                  <br />
                  <br />
                  <span>
                    5.7. You must not at any time transmit any content or other
                    information on the Service to another Customer or any other
                    party by way of a screen capture (or other similar method),
                    nor display any such information or content in a frame or in
                    any other manner that is different from how it would appear
                    if such Customer or third party had typed the URL for the
                    Service into the browser line.
                  </span>
                  <br />
                  <br />
                  <span>
                    5.8. When registering, you will receive possibility to use
                    all currencies available on the website. Those will be the
                    currencies of your deposits, withdrawals and bets placed and
                    matched into the Service as set out in these Terms. Some
                    payment methods do not process in all currencies. In such
                    cases a processing currency will be displayed, along with a
                    conversion calculator available on the page.
                  </span>
                  <br />
                  <br />
                  <span>
                    5.9. We are under no obligation to open an Account for you
                    and our website sign-up page is merely an invitation to
                    treat. It is entirely within our sole discretion whether or
                    not to proceed with the opening of an Account for you and,
                    should we refuse to open an Account for you, we are under no
                    obligation to provide you with a reason for the refusal.
                  </span>
                  <br />
                  <br />
                  <span>
                    5.10. Upon receipt of your application, we may be in touch
                    to request further information and/ or documentation from
                    you in order for us to comply with our regulatory and legal
                    obligations.
                  </span>
                  <br />
                  <br />
                  <br />
                  <span>6. Your Account</span>
                  <br />
                  <span>
                    6.1. Accounts could use several currencies, in this case all
                    Account balances and transactions appear in the currency
                    used for the transaction.
                  </span>
                  <br />
                  <br />
                  <span>
                    6.2. We do not give credit for the use of the Service.
                  </span>
                  <br />
                  <br />
                  <span>
                    6.3. We may close or suspend an Account if you are not or we
                    reasonably believe that you are not complying with these
                    Terms, or to ensure the integrity or fairness of the Service
                    or if we have other reasonable grounds to do so. We may not
                    always be able to give you prior notice. If we close or
                    suspend your Account due to you not complying with these
                    Terms, we may cancel and/or void any of your bets and
                    withhold any money in your account (including the deposit).
                  </span>
                  <br />
                  <br />
                  <span>
                    6.4. We reserve the right to close or suspend any Account
                    without prior notice and return all funds. Contractual
                    obligations already matured will however be honoured.
                  </span>
                  <br />
                  <br />
                  <span>
                    6.5. We reserve the right to refuse, restrict, cancel or
                    limit any wager at any time for whatever reason, including
                    any bet perceived to be placed in a fraudulent manner in
                    order to circumvent our betting limits and/ or our system
                    regulations.
                  </span>
                  <br />
                  <br />
                  <span>
                    6.6. If any amount is mistakenly credited to your Account it
                    remains our property and when we become aware of any such
                    mistake, we shall notify you and the amount will be
                    withdrawn from your Account.
                  </span>
                  <br />
                  <br />
                  <span>
                    6.7. If, for any reason, your Account goes overdrawn, you
                    shall be in debt to us for the amount overdrawn.
                  </span>
                  <br />
                  <br />
                  <span>
                    6.8. You must inform us as soon as you become aware of any
                    errors with respect to your Account.
                  </span>
                  <br />
                  <br />
                  <span>
                    6.9. Please remember that betting is purely for
                    entertainment and pleasure and you should stop as soon as it
                    stops being fun. Absolutely do not bet anything you can’t
                    afford to lose. If you feel that you may have lost control
                    of your gambling, we offer a self-exclusion option. Just
                    send a message to our Customer Support Department using your
                    Registered Email Address that you wish to SELF-EXCLUDE and
                    this request will take effect within 24 hours from the
                    moment of its receipt. In this case your account will be
                    disabled until your further notice, and you won’t be able to
                    login to it.
                  </span>
                  <br />
                  <br />
                  <span>
                    6.10. You cannot transfer, sell, or pledge Your Account to
                    another person. This prohibition includes the transfer of
                    any assets of value of any kind, including but not limited
                    to ownership of accounts, winnings, deposits, bets, rights
                    and/or claims in connection with these assets, legal,
                    commercial or otherwise. The prohibition on said transfers
                    also includes however is not limited to the encumbrance,
                    pledging, assigning, usufruct, trading, brokering,
                    hypothecation and/or gifting in cooperation with a fiduciary
                    or any other third party, company, natural or legal
                    individual, foundation and/or association in any way shape
                    or form
                  </span>
                  <br />
                  <br />
                  <span>
                    6.11. Should you wish to close your account with us, please
                    send an email from your Registered Email Address to our
                    Customer Support Department via the links on the Website.
                  </span>
                  <br />
                  <br />
                  <span>7. Inactive Accounts</span>
                  <br />
                  <span>
                    7.1. We will charge you a fee of €5 (or currency equivalent)
                    per calendar month (Inactive Account Fee) if:
                  </span>
                  <br />
                  <br />
                  <span>
                    you have not logged into your Account or logged out from
                    your Account, or used the Service, or made any bet in any
                    section of the Service for twelve consecutive months or more
                    (Account Activity);
                  </span>
                  <br />
                  <br />
                  <span>and your Account is in credit.</span>
                  <br />
                  <br />
                  <span>
                    7.2. You will be notified that we will start charging you
                    the fees on the eleventh month of inactivity and you will
                    always have the option to log in and withdraw your funds.
                  </span>
                  <br />
                  <br />
                  <span>
                    7.3. The Inactive Account Fee will be withdrawn from your
                    Account on a monthly basis to the extent that your Account
                    remains in credit and only for the period during which there
                    remains no Account Activity after the initial twelve month
                    period has passed. If the Inactive Account Fee is due to be
                    withdrawn from your Account and the balance of your Account
                    is less than €5 (or equivalent currency), the Inactive
                    Account Fee shall comprise the remaining funds in your
                    Account.
                  </span>
                  <br />
                  <br />
                  <br />
                  <span>8. Deposit of Funds</span>
                  <br />
                  <span>
                    8.1. All deposits should be made from an account or payment
                    system or credit card that is registered in your own name,
                    and any deposits made in any other currency will be
                    converted using the daily exchange rate obtained from
                    oanda.com, or at our own bank's or our payment processor’s
                    prevailing rate of exchange following which your Account
                    will be deposited accordingly. Note that some payment
                    systems may apply additional currency exchange fees which
                    will be deducted from the sum of your deposit.
                  </span>
                  <br />
                  <br />
                  <span>
                    8.2. Fees and charges may apply to customer deposits and
                    withdrawals, which can be found on the Website. In most
                    cases we absorb transaction fees for deposits to your &lt;
                    yourwebsite.com &gt; Account. You are responsible for your
                    own bank charges that you may incur due to depositing funds
                    with us.
                  </span>
                  <br />
                  <br />
                  <span>
                    8.3. Company is not a financial institution and uses a third
                    party electronic payment processors to process credit and
                    debit card deposits; they are not processed directly by us.
                    If you deposit funds by either a credit card or a debit
                    card, your Account will only be credited if we receive an
                    approval and authorisation code from the payment issuing
                    institution. If your card issuer gives no such
                    authorisation, your Account will not be credited with those
                    funds.
                  </span>
                  <br />
                  <br />
                  <span>
                    8.4. You agree to fully pay any and all payments and charges
                    due to us or to payment providers in connection with your
                    use of the Service. You further agree not to make any
                    charge-backs or renounce or cancel or otherwise reverse any
                    of your deposits, and in any such event you will refund and
                    compensate us for such unpaid deposits including any
                    expenses incurred by us in the process of collecting your
                    deposit, and you agree that any winnings from wagers
                    utilising those charged back funds will be forfeited. You
                    acknowledge and agree that your player account is not a bank
                    account and is therefore not guaranteed, insured or
                    otherwise protected by any deposit or banking insurance
                    system or by any other similar insurance system of any other
                    jurisdiction, including but not limited to your local
                    jurisdiction. Furthermore, the player account does not bear
                    interest on any of the funds held in it.
                  </span>
                  <br />
                  <br />
                  <span>
                    8.5. If you decide to accept any of our promotional or bonus
                    offer by entering a bonus code during deposit, you agree to
                    the Terms of Bonuses and terms of each specific bonus.
                  </span>
                  <br />
                  <br />
                  <span>
                    8.6. Funds originating from criminal and/or illegal and/or
                    unauthorized activities must not be deposited with us.
                  </span>
                  <br />
                  <br />
                  <span>
                    8.7. If you deposit using your credit card, it is
                    recommended that you retain a copy of Transaction Records
                    and a copy of these Terms.
                  </span>
                  <br />
                  <br />
                  <span>
                    8.8. Internet Gambling may be illegal in the jurisdiction in
                    which you are located; if so, you are not authorized to use
                    your payment card to deposit on this site. It is your
                    responsibility to know the laws concerning online gambling
                    in your country of domicile.
                  </span>
                  <br />
                  <br />
                  <br />
                  <span>9. Withdrawal of Funds</span>
                  <br />
                  <span>
                    9.1. You may withdraw any unutilized and cleared funds held
                    in your player account by submitting a withdrawal request in
                    accordance with our withdrawal conditions. The minimum
                    withdrawal amount per transaction is € 10 (or equivalent in
                    other currency) with the exception of an account closure in
                    which case you may withdraw the full balance.
                  </span>
                  <br />
                  <br />
                  <span>
                    9.2. There are no withdrawal commissions if you roll over
                    (wager) the deposit at least 1 time. Otherwise we are
                    entitled to deduct a 8% fee with minimum sum of 4 euro (or
                    equivalent in your account currency) in order to combat
                    money laundering.
                  </span>
                  <br />
                  <br />
                  <span>
                    9.3. We reserve the right to request photo ID, address
                    confirmation or perform additional verification procedures
                    (request your selfie, arrange a verification call etc.) for
                    the purpose of identity verification prior to granting any
                    withdrawals from your Account. We also reserve our rights to
                    perform identity verification at any time during the
                    lifetime of your relationship with us
                  </span>
                  <br />
                  <br />
                  <span>
                    9.4. All withdrawals must be made to the original debit,
                    credit card, bank account, method of payment used to make
                    the payment to your Account. We may, and always at our own
                    discretion, allow you to withdraw to a payment method from
                    which your original deposit did not originate. This will
                    always be subject to additional security checks.
                  </span>
                  <br />
                  <br />
                  <span>
                    9.5. Should you wish to withdraw funds but your account is
                    either inaccessible, dormant, locked or closed, please
                    contact our Customer Service Department.
                  </span>
                  <br />
                  <br />
                  <span>
                    9.6. In cases when your balance is at least 10 times larger
                    than the total sum of your deposits, you will be limited to
                    € 5,000 (or currency equivalent) for withdrawal per month.
                    In other cases the maximum withdrawal amount per month is €
                    10,000.
                  </span>
                  <br />
                  <br />
                  <span>
                    9.7. Please note that we cannot guarantee successful
                    processing of withdrawals or refunds in the event if you
                    breach the Restricted use policy stated in Clauses 3.3 and
                    4.
                  </span>
                  <br />
                  <br />
                  <br />
                  <span>10. Payment Transactions and Processors</span>
                </b>
                <br />
                <b>
                  <span>
                    10.1. You are fully responsible for paying all monies owed
                    to us. You must make all payments to us in good faith and
                    not attempt to reverse a payment made or take any action
                    which will cause such payment to be reversed by a third
                    party in order to avoid a liability legitimately incurred.
                    You will reimburse us for any charge-backs, denial or
                    reversal of payment you make and any loss suffered by us as
                    a consequence thereof. We reserve the right to also impose
                    an administration fee of €50, or currency equivalent per
                    charge-back, denial or reversal of payment you make.
                  </span>
                  <br />
                  <br />
                  <span>
                    10.2. We reserve the right to use third party electronic
                    payment processors and or merchant banks to process payments
                    made by you and you agree to be bound by their terms and
                    conditions providing they are made aware to you and those
                    terms do not conflict with these Terms.
                  </span>
                  <br />
                  <br />
                  <span>
                    10.3. All transactions made on our site might be checked to
                    prevent money laundering or terrorism financing activity.
                    Suspicious transactions will be reported to the relevant
                    authority.
                  </span>
                  <br />
                  <br />
                  <br />
                  <span>11. Errors</span>
                  <br />
                  <span>
                    11.1. In the event of an error or malfunction of our system
                    or processes, all bets are rendered void. You are under an
                    obligation to inform us immediately as soon as you become
                    aware of any error with the Service. In the event of
                    communication or system errors or bugs or viruses occurring
                    in connection with the Service and/or payments made to you
                    as a result of a defect or error in the Service, we will not
                    be liable to you or to any third party for any direct or
                    indirect costs, expenses, losses or claims arising or
                    resulting from such errors, and we reserve the right to void
                    all games/bets in question and take any other action to
                    correct such errors.
                  </span>
                  <br />
                  <br />
                  <span>
                    11.2. We make every effort to ensure that we do not make
                    errors in posting bookmaker lines. However, if as a result
                    of human error or system problems a bet is accepted at an
                    odd that is: materially different from those available in
                    the general market at the time the bet was made; or clearly
                    incorrect given the chance of the event occurring at the
                    time the bet was made then we reserve the right to cancel or
                    void that wager, or to cancel or void a wager made after an
                    event has started.
                  </span>
                  <br />
                  <br />
                  <span>
                    11.3. We have the right to recover from you any amount
                    overpaid and to adjust your Account to rectify any mistake.
                    An example of such a mistake might be where a price is
                    incorrect or where we enter a result of an event
                    incorrectly. If there are insufficient funds in your
                    Account, we may demand that you pay us the relevant
                    outstanding amount relating to any erroneous bets or wagers.
                    Accordingly, we reserve the right to cancel, reduce or
                    delete any pending plays, whether placed with funds
                    resulting from the error or not.
                  </span>
                  <br />
                  <br />
                  <br />
                  <span>12. Rules of Play, refunds and cancellations</span>
                  <br />
                  <span>
                    12.1. The winner of an event will be determined on the date
                    of the event's settlement, and we will not recognize
                    protested or overturned decisions for wagering purposes.
                  </span>
                  <br />
                  <br />
                  <span>
                    12.2. All results posted shall be final after 72 hours and
                    no queries will be entertained after that period of time.
                    Within 72 hours after results are posted, we will only
                    reset/correct the results due to human error, system error
                    or mistakes made by the referring results source.
                  </span>
                  <br />
                  <br />
                  <span>
                    12.3. If a match result is overturned for any reason by the
                    governing body of the match within the payout period then
                    all money will be refunded.
                  </span>
                  <br />
                  <br />
                  <span>
                    12.4. If a draw occurs in a game where a draw option is
                    offered all stakes on a team win or lose will be lost. If a
                    draw option is not offered then everyone receives a refund
                    in the outcome of a draw on the match. And if a draw option
                    has not been made available, then extra time will count, if
                    played.
                  </span>
                  <br />
                  <br />
                  <span>
                    12.5. If a result cannot be validated by us, for instance if
                    the feed broadcasting the event is interrupted (and cannot
                    be verified by another source) then at our election, the
                    wagers on that event will be deemed invalid and wagers
                    refunded.
                  </span>
                  <br />
                  <br />
                  <span>
                    12.6. Minimum and maximum wager amounts on all events will
                    be determined by us and are subject to change without prior
                    written notice. We also reserve the right to adjust limits
                    on individual Accounts as well.
                  </span>
                  <br />
                  <br />
                  <span>
                    12.7. Customers are solely responsible for their own Account
                    transactions. Once a transaction is complete, it cannot be
                    changed. We do not take responsibility for missing or
                    duplicate wagers made by the Customer and will not entertain
                    discrepancy requests because a play is missing or
                    duplicated. Customers may review their transactions in the
                    My Account section of the site after each session to ensure
                    all requested wagers were accepted.
                  </span>
                  <br />
                  <br />
                  <span>
                    12.8. A matchup will have action as long as the two teams
                    are correct, and regardless of the League header in which it
                    is placed on our Website.
                  </span>
                  <br />
                  <br />
                  <span>
                    12.9. The start dates and times displayed on the Website for
                    eSport matches are an indication only and are not guaranteed
                    to be correct. If a match is suspended or postponed, and not
                    resumed within 72 hours from the actual scheduled start
                    time, the match will have no action and wagers will be
                    refunded. The exception being any wager on whether a
                    team/player advances in a tournament, or wins the
                    tournament, will have action regardless of a suspended or
                    postponed match.
                  </span>
                  <br />
                  <br />
                  <span>
                    12.10. If an event is posted by us with an incorrect date,
                    all wagers have action based on the date announced by the
                    governing body.
                  </span>
                  <br />
                  <br />
                  <span>
                    12.11. If a team is using stand-ins, the result is still
                    valid as it was the team's choice to use the stand-ins.
                  </span>
                  <br />
                  <br />
                  <span>
                    12.12. Company reserves the right to remove events, markets
                    and any other products from the Website.
                  </span>
                  <br />
                  <br />
                  <span>
                    12.13. In-depth explanation of our sports betting rules is
                    on the separate page: SPORTS BETTING RULES
                  </span>
                  <br />
                  <br />
                  <br />
                  <span>13. Communications and Notices</span>
                  <br />
                  <span>
                    13.1. All communications and notices to be given under these
                    Terms by you to us shall be sent using a Customer Support
                    form on the Website.
                  </span>
                  <br />
                  <br />
                  <span>
                    13.2. All communications and notices to be given under these
                    Terms by us to you shall, unless otherwise specified in
                    these Terms, be either posted on the Website and/or sent to
                    the Registered Email Address we hold on our system for the
                    relevant Customer. The method of such communication shall be
                    in our sole and exclusive discretion.
                  </span>
                  <br />
                  <br />
                  <span>
                    13.3. All communications and notices to be given under these
                    Terms by either you or us shall be in writing in the English
                    language and must be given to and from the Registered Email
                    Address in your Account.
                  </span>
                  <br />
                  <br />
                  <span>
                    13.4. From time to time, we may contact you by email for the
                    purpose of offering you information about betting, unique
                    promotional offerings, and other information from{" "}
                  </span>
                  <a href="https://bajifair.live/">
                    <span>https://bajifair.live/</span>
                  </a>
                  <span>
                    . You agree to receive such emails when you agree to these
                    Terms when registering at the Website. You can choose to opt
                    out of receiving such promotional offerings from us at any
                    time by submitting a request to the Customer Support.
                  </span>
                  <br />
                  <br />
                  <br />
                  <span>14. Matters Beyond Our Control</span>
                  <br />
                  <span>
                    We cannot be held liable for any failure or delay in
                    providing the Service due to an event of Force Majeure which
                    could reasonably be considered to be outside our control
                    despite our execution of reasonable preventative measures
                    such as: an act of God; trade or labour dispute; power cut;
                    act, failure or omission of any government or authority;
                    obstruction or failure of telecommunication services; or any
                    other delay or failure caused by a third party, and we will
                    not be liable for any resulting loss or damage that you may
                    suffer. In such an event, we reserve the right to cancel or
                    suspend the Service without incurring any liability.
                  </span>
                </b>
                <br />
                <br />
                <br />
                <b>
                  <span>15. Liability</span>
                </b>
                <br />
                <b>
                  <span>
                    15.1. To the extent permitted by applicable law, we will not
                    compensate you for any reasonably foreseeable loss or damage
                    (either direct or indirect) you may suffer if we fail to
                    carry out our obligations under these terms unless we breach
                    any duties imposed on us by law (including if we cause death
                    or personal injury by our negligence) in which case we shall
                    not be liable to you if that failure is attributed to: (I)
                    your own fault; (II) a third party unconnected with our
                    performance of these terms (for instance problems due to
                    communications network performance, congestion, and
                    connectivity or the performance of your computer equipment);
                    or (III) any other events which neither we nor our suppliers
                    could have foreseen or forestalled even if we or they had
                    taken reasonable care. As this service is for consumer use
                    only we will not be liable for any business losses of any
                    kind.
                  </span>
                  <br />
                  <br />
                  <br />
                  <span>
                    15.2. In the event that we are held liable for any event
                    under these terms, our total aggregate liability to you
                    under or in connection with these terms shall not exceed (a)
                    the value of the bets and or wagers you placed via your
                    account in respect of the relevant bet/wager or product that
                    gave rise to the relevant liability, or (b) eur €500 in
                    aggregate, whichever is lower.
                  </span>
                  <br />
                  <br />
                  <br />
                  <span>
                    15.3. We strongly recommend that you (I) take care to verify
                    the suitability and compatibility of the service with your
                    own computer equipment prior to use; and (II) take
                    reasonable precautions to protect yourself against harmful
                    programs or devices including through installation of
                    anti-virus software.
                  </span>
                </b>
                <br />
                <br />
                <br />
                <b>
                  <span>16. Gambling By Those Under Age</span>
                  <br />
                  <span>
                    16.1. If we suspect that you are or receive notification
                    that you are currently under 18 years or were under 18 years
                    (or below the age of majority as stipulated in the laws of
                    the jurisdiction applicable to you) when you placed any bets
                    through the Service your Account will be suspended (locked)
                    to prevent you placing any further bets or making any
                    withdrawals from your Account. We will then investigate the
                    matter, including whether you have been betting as an agent
                    for, or otherwise on behalf, of a person under 18 years (or
                    below the age of majority as stipulated in the laws of the
                    jurisdiction applicable to you). If having found that you:
                    (a) are currently; (b) were under 18 years or below the
                    majority age which applies to you at the relevant time; or
                    (c) have been betting as an agent for or at the behest of a
                    person under 18 years or below the majority age which
                    applies:
                  </span>
                  <br />
                  <br />
                  <span>
                    * all winnings currently or due to be credited to your
                    Account will be retained;
                  </span>
                  <br />
                  <br />
                  <span>
                    * all winnings gained from betting through the Service
                    whilst under age must be paid to us on demand (if you fail
                    to comply with this provision we will seek to recover all
                    costs associated with recovery of such sums); and/or
                  </span>
                  <br />
                  <br />
                  <span>
                    * any monies deposited in your Account which are not
                    winnings will be returned to you OR retained until you turn
                    18 years old at our sole discretion. We reserve the right to
                    deduct payment transaction fees from the amount to return,
                    including transaction fees for deposits to your{" "}
                  </span>
                  <a href="https://bajifair.live/">
                    <span>https://bajifair.live/</span>
                  </a>
                  <span> account which we covered.</span>
                  <br />
                  <br />
                  <span>
                    16.2. This condition also applies to you if you are over the
                    age of 18 years but you are placing your bets within a
                    jurisdiction which specifies a higher age than 18 years for
                    legal betting and you are below that legal minimum age in
                    that jurisdiction.
                  </span>
                  <br />
                  <br />
                  <span>
                    16.3. In the event we suspect you are in breach of the
                    provisions of this Clause or are attempting to rely on them
                    for a fraudulent purpose, we reserve the right to take any
                    action necessary in order to investigate the matter,
                    including informing the relevant law enforcement agencies.
                  </span>
                  <br />
                  <br />
                  <br />
                  <span>17. Fraud</span>
                  <br />
                  <span>
                    We will seek criminal and contractual sanctions against any
                    Customer involved in fraud, dishonesty or criminal acts. We
                    will withhold payment to any Customer where any of these are
                    suspected. The Customer shall indemnify and shall be liable
                    to pay to us on demand all costs, charges or losses
                    sustained or incurred by us (including any direct, indirect
                    or consequential losses, loss of profit, loss of business
                    and loss of reputation) arising directly or indirectly from
                    the Customer’s fraud, dishonesty or criminal act.
                  </span>
                  <br />
                  <br />
                  <br />
                  <span>18. Intellectual Property</span>
                  <br />
                  <span>
                    18.1. Any unauthorised use of our name and logo may result
                    in legal action being taken against you.
                  </span>
                  <br />
                  <br />
                  <span>
                    18.2. As between us and you, we are the sole owners of the
                    rights in and to the Service, our technology, software and
                    business systems (the "Systems") as well as our odds. you
                    must not use your personal profile for your own commercial
                    gain (such as selling your status update to an advertiser);
                    and when selecting a nickname for your Account we reserve
                    the right to remove or reclaim it if we believe it
                    appropriate.
                  </span>
                  <br />
                  <br />
                  <span>
                    18.3. You may not use our URL, trademarks, trade names
                    and/or trade dress, logos ("Marks") and/or our odds in
                    connection with any product or service that is not ours,
                    that in any manner is likely to cause confusion among
                    Customers or in the public or that in any manner disparages
                    us.
                  </span>
                  <br />
                  <br />
                  <span>
                    18.4. Except as expressly provided in these Terms, we and
                    our licensors do not grant you any express or implied
                    rights, license, title or interest in or to the Systems or
                    the Marks and all such rights, license, title and interest
                    specifically retained by us and our licensors. You agree not
                    to use any automatic or manual device to monitor or copy web
                    pages or content within the Service. Any unauthorized use or
                    reproduction may result in legal action being taken against
                    you.
                  </span>
                  <br />
                  <br />
                  <br />
                  <span>19. Your Licence</span>
                  <br />
                  <span>
                    19.1. Subject to these Terms and your compliance with them,
                    we grant to you a non-exclusive, limited, non transferable
                    and non sub-licensable license to access and use the Service
                    for your personal non-commercial purposes only. Our license
                    to you terminates if our agreement with you under these
                    Terms ends.
                  </span>
                  <br />
                  <br />
                  <span>
                    19.2. Save in respect of your own content, you may not under
                    any circumstances modify, publish, transmit, transfer, sell,
                    reproduce, upload, post, distribute, perform, display,
                    create derivative works from, or in any other manner
                    exploit, the Service and/or any of the content thereon or
                    the software contained therein, except as we expressly
                    permit in these Terms or otherwise on the Website. No
                    information or content on the Service or made available to
                    you in connection with the Service may be modified or
                    altered, merged with other data or published in any form
                    including for example screen or database scraping and any
                    other activity intended to collect, store, reorganise or
                    manipulate such information or content.
                  </span>
                  <br />
                  <br />
                  <span>
                    19.3. Any non-compliance by you with this Clause may also be
                    a violation of our or third parties' intellectual property
                    and other proprietary rights which may subject you to civil
                    liability and/or criminal prosecution.
                  </span>
                  <br />
                  <br />
                  <br />
                  <span>20. Your Conduct and Safety</span>
                  <br />
                  <span>
                    20.1. For your protection and protection of all our
                    Customers, the posting of any content on the Service, as
                    well as conduct in connection therewith and/or the Service,
                    which is in any way unlawful, inappropriate or undesirable
                    is strictly prohibited (“Prohibited Behaviour”).
                  </span>
                  <br />
                  <br />
                  <span>
                    20.2. If you engage in Prohibited Behaviour, or we determine
                    in our sole discretion that you are engaging in Prohibited
                    Behaviour, your Account and/or your access to or use of the
                    Service may be terminated immediately without notice to you.
                    Legal action may be taken against you by another Customer,
                    other third party, enforcement authorities and/or us with
                    respect to you having engaged in Prohibited Behaviour.
                  </span>
                  <br />
                  <br />
                  <span>
                    20.3. Prohibited Behaviour includes, but is not limited to,
                    accessing or using the Service to: promote or share
                    information that you know is false, misleading or unlawful;
                    conduct any unlawful or illegal activity, such as, but not
                    limited to, any activity that furthers or promotes any
                    criminal activity or enterprise, violates another Customer's
                    or any other third party’s privacy or other rights or that
                    creates or spreads computer viruses; harm minors in any way;
                  </span>
                  <br />
                  <br />
                  <span>
                    transmit or make available any content that is unlawful,
                    harmful, threatening, abusive, tortuous, defamatory, vulgar,
                    obscene, lewd, violent, hateful, or racially or ethnically
                    or otherwise objectionable;
                  </span>
                  <br />
                  <br />
                  <span>
                    transmit or make available any content that the user does
                    not have a right to make available under any law or
                    contractual or fiduciary relationship, including without
                    limitation, any content that infringes a third party’s
                    copyright, trademark or other intellectual property and
                    proprietary rights;
                  </span>
                  <br />
                  <br />
                  <span>
                    transmit or make available any content or material that
                    contains any software virus or other computer or programming
                    code (including HTML) designed to interrupt, destroy or
                    alter the functionality of the Service, its presentation or
                    any other website, computer software or hardware;
                  </span>
                  <br />
                  <br />
                  <span>
                    interfere with, disrupt or reverse engineer the Service in
                    any manner, including, without limitation, intercepting,
                    emulating or redirecting the communication protocols used by
                    us, creating or using cheats, mods or hacks or any other
                    software designed to modify the Service, or using any
                    software that intercepts or collects information from or
                    through the Service; retrieve or index any information from
                    the Service using any robot, spider or other automated
                    mechanism;
                  </span>
                  <br />
                  <br />
                  <span>
                    participate in any activity or action that, in the sole and
                    entire unfettered discretion of us results or may result in
                    another Customer being defrauded or scammed; transmit or
                    make available any unsolicited or unauthorised advertising
                    or mass mailing such as, but not limited to, junk mail,
                    instant messaging, "spim", "spam", chain letters, pyramid
                    schemes or other forms of solicitations;
                  </span>
                  <br />
                  <br />
                  <span>
                    create Accounts on the Website by automated means or under
                    false or fraudulent pretences; impersonate another Customer
                    or any other third party, or any other act or thing done
                    that we reasonably consider to be contrary to our business
                    principles.
                  </span>
                  <br />
                  <br />
                  <span>
                    The above list of Prohibited Behaviour is not exhaustive and
                    may be modified by us at any time or from time to time. We
                    reserve the right to investigate and to take all such
                    actions as we in our sole discretion deem appropriate or
                    necessary under the circumstances, including without
                    limitation deleting the Customer’s posting(s) from the
                    Service and/or terminating their Account, and take any
                    action against any Customer or third party who directly or
                    indirectly in, or knowingly permits any third party to
                    directly or indirectly engage in Prohibited Behaviour, with
                    or without notice to such Customer or third party.
                  </span>
                  <br />
                  <br />
                  <br />
                  <span>21. Links to Other Websites</span>
                  <br />
                  <span>
                    The Service may contain links to third party websites that
                    are not maintained by, or related to, us, and over which we
                    have no control. Links to such websites are provided solely
                    as a convenience to Customers, and are in no way
                    investigated, monitored or checked for accuracy or
                    completeness by us. Links to such websites do not imply any
                    endorsement by us of, and/or any affiliation with, the
                    linked websites or their content or their owner(s). We have
                    no control over or responsibility for the availability nor
                    their accuracy, completeness, accessibility and usefulness.
                    Accordingly when accessing such websites we recommend that
                    you should take the usual precautions when visiting a new
                    website including reviewing their privacy policy and terms
                    of use.
                  </span>
                  <br />
                  <br />
                  <br />
                  <span>22. Complaints</span>
                  <br />
                  <span>
                    22.1. If you have any concerns or questions regarding these
                    Terms you should contact our Customer Service Department via
                    the links on the Website and use your Registered Email
                    Address in all communication with us.
                  </span>
                  <br />
                  <br />
                  <span>
                    22.2. NOTWITHSTANDING THE FOREGOING, WE TAKE NO LIABILITY
                    WHATSOEVER TO YOU OR TO ANY THIRD PARTY WHEN RESPONDING TO
                    ANY COMPLAINT THAT WE RECEIVED OR TOOK ACTION IN CONNECTION
                    THEREWITH.
                  </span>
                  <br />
                  <br />
                  <span>
                    22.3. If a Customer is not satisfied with how a bet has been
                    settled then the Customer should provide details of their
                    grievance to our Customer Service Department. We shall use
                    our reasonable endeavours to respond to queries of this
                    nature within a few days (and in any event we intend to
                    respond to all such queries within 28 days of receipt).
                  </span>
                  <br />
                  <br />
                  <span>
                    22.4. Disputes must be lodged within three (3) days from the
                    date the wager in question has been decided. No claims will
                    be honoured after this period. The Customer is solely
                    responsible for their Account transactions.
                  </span>
                  <br />
                  <br />
                  <span>
                    22.5. In the event of a dispute arising between you and us
                    our Customer Service Department will attempt to reach an
                    agreed solution. Should our Customer Service Department be
                    unable to reach an agreed solution with you, the matter will
                    be escalated to our management.
                  </span>
                  <br />
                  <br />
                  <span>
                    22.6. Should all efforts to resolve a dispute to the
                    Customer's satisfaction have failed, the Customer has the
                    right to lodge a complaint with our licensing body Gaming
                    Services Provider N.V.
                  </span>
                  <br />
                  <br />
                  <br />
                  <span>23. Assignment</span>
                  <br />
                  <span>
                    Neither these Terms nor any of the rights or obligations
                    hereunder may be assigned by you without the prior written
                    consent of us, which consent will not be unreasonably
                    withheld. We may, without your consent, assign all or any
                    portion of our rights and obligations hereunder to any third
                    party provided such third party is able to provide a service
                    of substantially similar quality to the Service by posting
                    written notice to this effect on the Service.
                  </span>
                  <br />
                  <br />
                  <br />
                  <span>24. Severability</span>
                  <br />
                  <span>
                    In the event that any provision of these Terms is deemed by
                    any competent authority to be unenforceable or invalid, the
                    relevant provision shall be modified to allow it to be
                    enforced in line with the intention of the original text to
                    the fullest extent permitted by applicable law. The validity
                    and enforceability of the remaining provisions of these
                    Terms shall not be affected.
                  </span>
                  <br />
                  <br />
                  <br />
                  <span>25. Breach of These Terms</span>
                  <br />
                  <span>
                    Without limiting our other remedies, we may suspend or
                    terminate your Account and refuse to continue to provide you
                    with the Service, in either case without giving you prior
                    notice, if, in our reasonable opinion, you breach any
                    material term of these Terms. Notice of any such action
                    taken will, however, be promptly provided to you.
                  </span>
                  <br />
                  <br />
                  <br />
                  <span>26. General Provisions</span>
                  <br />
                  <span>26.1. </span>
                  <span>Term of agreement.</span>
                  <span>
                    {" "}
                    These Terms shall remain in full force and effect while you
                    access or use the Service or are a Customer or visitor of
                    the Website. These Terms will survive the termination of
                    your Account for any reason.
                  </span>
                  <br />
                  <br />
                  <span>26.2. </span>
                  <span>Gender.</span>
                  <span>
                    {" "}
                    Words importing the singular number shall include the plural
                    and vice versa, words importing the masculine gender shall
                    include the feminine and neuter genders and vice versa and
                    words importing persons shall include individuals,
                    partnerships, associations, trusts, unincorporated
                    organisations and corporations.
                  </span>
                  <br />
                  <br />
                  <span>26.3. </span>
                  <span>Waiver.</span>
                  <span>
                    {" "}
                    No waiver by us, whether by conduct or otherwise, of a
                    breach or threatened breach by you of any term or condition
                    of these Terms shall be effective against, or binding upon,
                    us unless made in writing and duly signed by us, and, unless
                    otherwise provided in the written waiver, shall be limited
                    to the specific breach waived. The failure of us to enforce
                    at any time any term or condition of these Terms shall not
                    be construed to be a waiver of such provision or of the
                    right of us to enforce such provision at any other time.
                  </span>
                  <br />
                  <br />
                  <span>26.4. </span>
                  <span>Acknowledgement.</span>
                  <span>
                    {" "}
                    By hereafter accessing or using the Service, you acknowledge
                    having read, understood and agreed to each and every
                    paragraph of these Terms. As a result, you hereby
                    irrevocably waive any future argument, claim, demand or
                    proceeding to the contrary of anything contained in these
                    Terms.
                  </span>
                  <br />
                  <br />
                  <span>26.5. </span>
                  <span>Language.</span>
                  <span>
                    {" "}
                    In the event of there being a discrepancy between the
                    English language version of these rules and any other
                    language version, the English language version will be
                    deemed to be correct.
                  </span>
                  <br />
                  <br />
                  <span>26.6. </span>
                  <span>Governing Law.</span>
                  <span>
                    {" "}
                    These Terms are governed by the law in force in Curaçao
                    exclusively.
                  </span>
                  <br />
                  <br />
                  <span>26.7. </span>
                  <span>Entire agreement.</span>
                  <span>
                    {" "}
                    These Terms constitute the entire agreement between you and
                    us with respect to your access to and use of the Service,
                    and supersedes all other prior agreements and
                    communications, whether oral or written with respect to the
                    subject matter hereof.
                  </span>
                </b>
                <br />
                <br />
                <br />
                &nbsp;
              </p>
            </div>
          </div>

          <div
            _ngcontent-serverapp-c3368753927
            className="content-box ng-star-inserted"
          >
            <div _ngcontent-serverapp-c3368753927 className="title">
              {t("RulesAndRegulations")}
            </div>
            <div _ngcontent-serverapp-c3368753927>
              <p>
                <b>
                  <span>Rules and Regulations</span>
                </b>
              </p>
              <h4 dir="ltr">
                <b>
                  <span>NOTE:</span>
                </b>
              </h4>
              <h4 dir="ltr">
                <b>
                  <span>
                    Players using VPN and login from different IP frequently may
                    result in void bets.
                  </span>
                </b>
              </h4>
              <h4 dir="ltr">
                <b>
                  <span>
                    And on the basis of different IP from multiple cities we can
                    suspend the account and void bets.
                  </span>
                </b>
              </h4>
              <p dir="ltr">
                <b>
                  <span>
                    All users are advised to read the following ‘Terms and
                    Conditions’. All users who use Sportsbook agree and accept
                    to the following:
                  </span>
                  <br />
                  <br />
                  <span>
                    1. Any form of ‘Passing of funds’, ‘Self Matching’ will not
                    be tolerated. Any users found participating in such
                    activities will be locked with the funds being reversed.
                    bajifair reserves the right at absolute discretion to void
                    such bets and suspend any participating accounts without
                    notice.
                  </span>
                  <br />
                  <br />
                  <span>
                    2. Please note that if any account has been locked due to
                    ‘Passing of funds’ within the last 72 hours, the company
                    reserves the right to void any bet of this nature within the
                    account irrespective of when the bet was placed.
                  </span>
                  <br />
                  <br />
                  <span>
                    3. No Arguments or claims in the above context will be
                    entertained by the company and the decision made by the
                    company will stand as final.
                  </span>
                  <br />
                  <br />
                  <span>
                    4. We are committed to having our services running 24/7.
                    However, due to any technical issues, and/or disruption of
                    services from our provider, the company will not be held
                    liable for any market positions that any account holders may
                    hold.
                  </span>
                  <br />
                  <br />
                  <span>
                    5. bajifair reserves the right to resettle, and/or void any
                    markets for reasons such as technical delay from the
                    provider. In such a case, we will settle according to the
                    provider as final.
                  </span>
                  <br />
                  <br />
                  <span>
                    6. In case anyone is found using 2 different IDs and logging
                    in from the same IP his winning in both accounts will be
                    cancelled.
                  </span>
                  <br />
                  <br />
                  <span>
                    7. Any bets which are deemed of being suspicious, including
                    bets which have been placed from the stadium or from a
                    source at the stadium may be voided at any time. The
                    decision of whether to void the particular bet in question
                    or to void the entire market will remain at the discretion
                    of the company. The final decision of whether bets are
                    suspicious will be taken by the company and that decision
                    will be full and final.
                  </span>
                  <br />
                  <br />
                  <span>
                    8. Any sort of cheating bet, any sort of Matching (Passing
                    of funds), Court Siding (Ghaobaazi on commentary),
                    Sharpening, Commission making is not allowed, If any user is
                    caught in any such act then all the funds belonging to that
                    account would be seized and confiscated. No argument or
                    claim in that context would be entertained and the decision
                    made by management will stand as final authority.
                  </span>
                  <br />
                  <br />
                  <span>
                    9. Fluke hunting/Seeking is prohibited, All the fluke bets
                    will be reversed. Cricket commentary is just an additional
                    feature and facility for users but the company is not
                    responsible for any delay or mistake in commentary.
                  </span>
                  <br />
                  <br />
                  <span>Part A - Introduction</span>
                  <br />
                  <span>Restricted territory information</span>
                  <br />
                  <span>
                    Please be advised that our restricted territory information
                    pertains to both residents and visitors in the restricted
                    areas. Accounts registered in a non-restricted territory
                    will become restricted if they attempt to access and have
                    betting activity from a territory which is restricted.
                  </span>
                  <br />
                  <br />
                  <span>
                    Restricted territory countries are United States of America
                    and its territories, France and its territories, Netherlands
                    and its territories and countries that form the Kingdom of
                    Netherlands including Bonaire, Sint Eustatius, Saba, Aruba,
                    Curacao and Sint Maarten, Australia and its territories,
                    United Kingdom of Great Britain, Northern Ireland, Spain,
                    and Cyprus.
                  </span>
                  <br />
                  <br />
                  <span>
                    We have the right to void all players' winnings if they are
                    deemed to come from a restricted territory.
                  </span>
                  <br />
                  <br />
                  <span>1. Use and interpretation</span>
                  <br />
                  <span>
                    The Sportsbook Rules and Regulations ("Sportsbook Rules")
                    are part of terms and conditions.
                  </span>
                  <br />
                  <br />
                  <span>
                    The Sportsbook Rules apply to all bets placed on Sportsbook
                    markets. The Sportsbook Rules also apply to Sportsbook
                    ’Multiples’ products (see the Multiples section below for
                    further details). The Sportsbook Rules consist of the
                    following:
                  </span>
                  <br />
                  <br />
                  <span>* This INTRODUCTION section (Part A);</span>
                  <br />
                  <br />
                  <span>* The GENERAL RULES (set out in Part B below);</span>
                  <br />
                  <br />
                  <span>
                    * The SPECIFIC SPORTS RULES (set out in Part C below – these
                    apply to certain sports and to financial markets); and
                  </span>
                  <br />
                  <br />
                  <span>
                    * The MARKET INFORMATION (located on every market either
                    under the tab entitled "Rules" or under the ‘Rules’).
                  </span>
                  <br />
                  <br />
                  <span>
                    The General Rules apply to all bets unless stated otherwise
                    in the Market Information or the Specific Sports Rules. If
                    there is any inconsistency between the Specific Sports Rules
                    and the General Rules, the Specific Sports Rules shall
                    prevail. If there is any inconsistency between the Market
                    Information and either the General Rules or the Specific
                    Sports Rules, the Market Information shall prevail, except
                    where the General Rules or Specific Sports Rules use the
                    phrase 'regardless of what it says in the Market
                    Information' or similar wording.
                  </span>
                  <br />
                  <br />
                  <span>
                    For any category or market not referred to in the Specific
                    Sports Rules (e.g. ’Special Bets’ or beach volleyball), the
                    General Rules and Market Information will apply.
                  </span>
                  <br />
                  <br />
                  <br />
                  <span>2. Market information</span>
                  <br />
                  <span>
                    The Market Information is provided for information purposes
                    as an at-a-glance guide on how to manage the market. The
                    Market Information may also contain rules on market
                    settlement, however it must always be read in conjunction
                    with the General Rules and the relevant Specific Sports
                    Rules and a link to this Rules and Regulations page will
                    usually be provided in the Market Information for each
                    market.
                  </span>
                </b>
                <br />
                <br />
                <b>
                  <span>
                    Whilst the Market Information may give a guide to how
                    markets will be managed, regardless of what it says in the
                    Market Information, it reserves the right to suspend any
                    market at any time at its sole discretion, including in
                    order to carry out necessary administration and/or to take
                    any necessary action to protect the customers.
                  </span>
                  <br />
                  <br />
                  <span>
                    It shall not amend the Market Information after a market has
                    been loaded except to correct obvious errors and/or to add
                    wording to clarify the Market Information where appropriate.
                  </span>
                  <br />
                  <br />
                  <br />
                  <span>3. Customer responsibility</span>
                  <br />
                  <span>
                    The customers should make themselves aware of all the
                    Sportsbook Rules affecting any market on which they wish to
                    place a bet. Customers should not simply rely on the Market
                    Information as the Market Information is unlikely to contain
                    all of the applicable rules relating to a market.
                  </span>
                  <br />
                  <br />
                  <span>
                    By their nature ‘Special Bets’ markets are unpredictable so
                    should be treated with particular caution. Customers are
                    responsible for managing their own positions at all times in
                    such markets. Customers should pay particular attention to
                    the Market Information on ‘Special Bets’ markets to ensure
                    they understand the basis on which the market will be
                    administered and settled.
                  </span>
                  <br />
                  <br />
                  <br />
                  <span>4. Customer betting disputes &amp; IBAS</span>
                  <br />
                  <span>
                    Any customer who has any concerns or questions regarding the
                    Sportsbook Rules or regarding the settlement of any market
                    should contact.
                  </span>
                </b>
                <br />
                <br />
                <b>
                  <span>
                    If a customer is not satisfied with how a bet or a market
                    has been settled then the customer should provide details of
                    their grievance.
                  </span>
                  <br />
                  <br />
                  <br />
                  <span>Part B - General rules</span>
                  <br />
                  <span>1. Managing markets In-Play</span>
                  <br />
                  <br />
                  <span>a) General</span>
                  <br />
                  <span>
                    * If a market is not scheduled to be turned in-play but
                    fails to suspend the market at the relevant time, then:
                  </span>
                  <br />
                  <span>
                    &nbsp;
                    <br />* if the event has a scheduled 'off' time, all bets
                    matched after that scheduled off time will be void; and
                  </span>
                  <br />
                  <span>
                    &nbsp; &nbsp;
                    <br />* if the event does not have a scheduled 'off' time,
                    it will use its reasonable endeavours to ascertain the time
                    of the actual 'off' and all bets after the time of the 'off'
                    determined will be void.
                  </span>
                  <br />
                  <br />
                  <span>
                    * It aims to use its reasonable endeavours to suspend
                    in-play markets at the start of and at the end of the event.
                    However, regardless of what it says in the Market
                    Information, it does not guarantee that such markets will be
                    suspended at the relevant time.
                  </span>
                  <br />
                  <br />
                  <span>
                    * It will not part-suspend outcomes/selections in an
                    Sportsbook market that has been turned in-play.
                  </span>
                  <br />
                  <br />
                  <span>
                    * Customers are responsible for managing their in-play bets
                    at all times.
                  </span>
                  <br />
                  <br />
                  <span>
                    *For the purposes of in-play betting, customers should be
                    aware that transmissions described as "live" by some
                    broadcasters may be delayed or pre-recorded. The extent of
                    any delay may vary depending on the set-up through which
                    they are receiving pictures or data.
                  </span>
                  <br />
                  <br />
                  <span>
                    b) All markets other than soccer markets and Australian
                    markets - not suspending at the time of the 'off'
                  </span>
                  <br />
                  <span>
                    * In relation to markets which are scheduled to be turned
                    in-play, it aims to use its reasonable endeavours to turn
                    such markets in-play at the time of the 'off'. The time of
                    the 'off' for such markets should be set out in the Market
                    Information. However, regardless of what it says in the
                    Market Information, it does not guarantee that such markets
                    will be suspended and turned in-play at the time of the
                    'off'.
                  </span>
                  <br />
                  <br />
                  <span>
                    * If a market is scheduled to be turned in-play but does not
                    suspend the market and cancel unmatched bets at the time of
                    the 'off' and the market is not turned in-play with
                    unmatched bets cancelled at any time during the event, all
                    bets matched after the scheduled time of the 'off' will be
                    void.
                  </span>
                  <br />
                  <br />
                  <span>
                    * If the event does not have a scheduled 'off' time, it will
                    use its reasonable endeavours to ascertain the time of the
                    actual 'off' and all bets after the time of the 'off'
                    determined will be void.
                  </span>
                  <br />
                  <br />
                  <span>
                    * If a market is scheduled to be turned in-play but does not
                    suspend the market at the time of the 'off' (so unmatched
                    bets are not cancelled at that time), but the market is
                    intentionally turned in-play at a later time during the
                    event, all bets matched after the time of the 'off' will
                    stand
                  </span>
                  <br />
                  <br />
                  <span>
                    c) Soccer markets (with the exception of Australian soccer
                    markets) - not suspending at kick-off or on the occurrence
                    of a Material Event
                  </span>
                  <br />
                  <br />
                  <span>Not suspending at kick-off</span>
                  <br />
                  <br />
                  <span>
                    * In relation to soccer markets that are scheduled to be
                    turned in-play, it aims to use its reasonable endeavours to
                    turn such markets in-play at kick-off and to suspend such
                    markets on the occurrence of a Material Event (see
                    definition of "Material Event" below).
                  </span>
                  <br />
                  <br />
                  <span>
                    * The relevant scheduled kick-off time should be set out in
                    the Market Information. However, regardless of what it says
                    in the Market Information, it does not guarantee that such
                    markets will be suspended and turned in-play at kick-off.
                  </span>
                  <br />
                  <br />
                  <span>
                    * If a market is scheduled to be turned in-play but not
                    suspend the market at kick-off and the market is not turned
                    in-play at any time during the match, all bets matched after
                    the scheduled time of the kick-off will be void.
                  </span>
                  <br />
                  <br />
                  <span>
                    * If a market is scheduled to be turned in-play but not
                    suspend the market at kick-off (so unmatched bets are not
                    cancelled at that time), but the market is turned in-play at
                    a later time during the match, all bets matched after the
                    scheduled time of the kick-off and before the first
                    "Material Event" will stand. However, if there has been one
                    or more "Material Events", any bets matched between the
                    first "Material Event" and the market being turned in-play
                    will be void.
                  </span>
                  <br />
                  <br />
                  <span>
                    Not suspending on the occurrence of a Material Event
                  </span>
                  <br />
                  <br />
                  <span>
                    * If it does not suspend a market on time for the occurrence
                    of a Material Event, it reserves the right to void bets
                    unfairly matched after the Material Event has occurred.
                    Voiding of these bets may take place during the event or
                    retrospectively once a game is completed.
                  </span>
                  <br />
                  <br />
                  <span>Definition of “Material Event”</span>
                  <br />
                  <br />
                  <span>
                    * For the purpose of these Sportsbook Rules, a "Material
                    Event" shall mean a goal being scored, a penalty being
                    awarded or a player being sent off.
                  </span>
                  <br />
                  <br />
                  <span>d) In-play Australian markets</span>
                  <br />
                  <span>
                    * Notwithstanding the other in-play rules described above,
                    in relation specifically to any Australian market that is
                    scheduled to be turned in-play, if it fails to suspend the
                    market at the 'off' then all bets matched after the
                    scheduled time of the 'off' and before the market is turned
                    in-play will be void. If the event does not have a scheduled
                    'off' time, it will use its reasonable endeavours to
                    ascertain the time of the actual 'off' and all bets after
                    the time of the 'off' as determined will be void.
                  </span>
                  <br />
                  <br />
                  <span>2. Results and market settlement</span>
                  <br />
                  <span>&nbsp; a) General</span>
                  <br />
                  <span>
                    * Markets will be settled as set out in the Market
                    Information and/or the Specific Sports Rules.
                  </span>
                  <br />
                  <br />
                  <span>
                    * Where the Market Information or Specific Sports Rules do
                    not specify how and on what basis a market will be settled,
                    markets will be settled on the official result of the
                    relevant governing body regardless of any subsequent
                    disqualification or amendment to the result (except if an
                    amendment is announced within 24 hours of the initial
                    settlement of the relevant market in order to correct an
                    error in reporting the result).
                  </span>
                  <br />
                  <br />
                  <span>
                    * If no official result of a relevant governing body is
                    available, the result will be determined by using
                    information from independent sources. In such cases, if any
                    new information comes into the public domain within 48 hours
                    of settlement, then it shall (acting reasonably) determine
                    either: (i) whether the market should be reinstated or
                    resettled in light of this new information; or (ii) whether
                    or not to wait for further information before deciding
                    whether to reinstate or resettle the market. Except it has
                    announced that it is waiting for further information, any
                    information that comes into the public domain more than 48
                    hours after a market has been settled shall not be
                    considered (regardless of whether or not such information
                    may have led to a different result).
                  </span>
                  <br />
                  <br />
                  <span>
                    * In the event of any uncertainty about any result or
                    potential result, it reserves the right to suspend
                    settlement of any market for an unlimited period until the
                    uncertainty can be resolved to reasonable satisfaction. It
                    reserves the right to void any market if the uncertainty
                    regarding settlement cannot be resolved to reasonable
                    satisfaction.
                  </span>
                  <br />
                  <br />
                  <span>b) Resettlements</span>
                  <br />
                  <span>
                    * Markets are generally settled shortly after the end of the
                    event in question. It may settle (or part-settle) some
                    markets before the official result is declared (or may
                    increase a customer's 'available to bet' balance by the
                    minimum potential winnings of that customer on a given
                    market) purely as a customer service benefit. However, it
                    reserves the right to amend the settlement of the market if:
                    (i) the official result is different to the result on which
                    initially settled the market; or (ii) if the whole market is
                    eventually voided (e.g. for an abandoned event).
                  </span>
                  <br />
                  <br />
                  <span>
                    * It reserves the right to reverse the settlement of a
                    market if a market is settled in error (for example, a human
                    or technical error).
                  </span>
                  <br />
                  <br />
                  <span>
                    * If resettles a market, this may lead to amendments being
                    made to a customer's balance to reflect changes in market
                    settlement.
                  </span>
                  <br />
                  <br />
                  <span>c) Non-runners, withdrawals and disqualifications</span>
                  <br />
                  <span>
                    * Subject always right to void bets under its terms and
                    conditions or for any exception under the Sportsbook Rules,
                    if a market contains a statement that says, "All bets stand,
                    run or not" (or something similar) in the Market
                    Information, then all bets on a team or competitor will
                    stand regardless of whether or not the team or competitor
                    starts the event or takes any part in the event.
                  </span>
                  <br />
                  <br />
                  <span>
                    * Where the Market Information does not stipulate that all
                    bets will stand regardless of participation, customers
                    should refer to the relevant Specific Sports Rules.
                  </span>
                  <br />
                  <br />
                  <span>
                    * If a team or competitor is disqualified, withdraws or
                    forfeits after starting an event they will be deemed a loser
                    providing at least one other team or competitor completes
                    the event. If no team or competitor completes an event
                    (having started) then all bets will be void except for bets
                    on any markets which have been unconditionally determined.
                  </span>
                  <br />
                  <br />
                  <span>d) Winner with [named selection]' markets</span>
                  <br />
                  <span>
                    *It may from time to time offer markets that are dependent
                    on the participation of a particular competitor. If the
                    competitor named either in a 'Winner with …' market title or
                    in the Market Information does not participate in the
                    tournament or event then all bets on the market will be
                    void. For example, if there was a "Winner with Federer"
                    tennis market, all bets on the market would be void if
                    Federer did not participate in the tournament. However, if
                    any other competitor did not participate, then bets would
                    stand.
                  </span>
                  <br />
                  <br />
                  <span>
                    * A team or competitor will be deemed to have participated
                    if they have taken part to the extent necessary to record an
                    official result or classification (including any
                    disqualification but excluding any "did not start" or
                    equivalent classification).
                  </span>
                  <br />
                  <br />
                  <span>3. Abandonments, Cancellations, Postponements</span>
                  <br />
                  <span>* </span>
                  <span>
                    Some markets have different rules and these are listed in
                    the Specific Sports Rules and/or the Market Information.
                    However, where a market has no rules in the Specific Sports
                    Rules or the Market Information in relation to an
                    abandonment, cancellation and/or postponement the following
                    shall apply.
                  </span>
                  <br />
                  <br />
                  <span>
                    * In relation to any match, fixture, game, individual event,
                    race or similar: If the event is not completed within three
                    days after the scheduled completion date, then all bets on
                    markets for this event will be void, except for bets on any
                    markets that have been unconditionally determined.
                  </span>
                  <br />
                  <br />
                  <span>
                    * In relation to any tournament, competition or similar: If
                    the event is not completed within three days after the
                    scheduled completion date, then any markets relating to the
                    event will be settled in accordance with the official ruling
                    of the relevant governing body, providing such a decision is
                    given within 90 days after the scheduled completion date. If
                    no official ruling is announced in this 90-day period, then
                    bets on any market relating to this event will be void,
                    except for bets on any markets which have been
                    unconditionally determined. If a market is to be voided but
                    has been part-settled as a courtesy to customers, then such
                    part-settled bets will be reversed and all bets on the
                    market will be void.
                  </span>
                  <br />
                  <br />
                  <span>
                    * It will decide (acting reasonably) whether a market
                    relates to a match (or similar) or a tournament (or
                    similar). However, by way of example, the following shall
                    apply: (i) Europa League outright = tournament; (ii)
                    Champions’ League Group outright = tournament; (iii) Top
                    Premiership goal scorer = tournament; (iv) Tennis Tournament
                    outright = tournament;(v) 5-day Cricket Test Match = match;
                    (vi) Ashes Series outright winner = tournament.
                  </span>
                  <br />
                  <br />
                  <span>4. Change of venue</span>
                  <br />
                  <span>*</span>
                  <span> </span>
                  <span>
                    Some markets have different rules and these are listed in
                    the Specific Sports Rules and/or the Market Information.
                    However, if change of venue is not dealt with in the
                    Specific Sports Rules and/or the Market Information then the
                    following shall apply:
                  </span>
                  <br />
                  <br />
                  <span>
                    * For any team sport: if the scheduled venue is changed
                    after the market is loaded, all bets will be void only if
                    the new venue is a home ground of the original away team
                  </span>
                  <br />
                  <br />
                  <span>
                    * For all categories or markets other than team sports: if
                    the scheduled venue is changed after the market is loaded,
                    all bets will stand.
                  </span>
                  <br />
                  <br />
                  <span>
                    * If there is a change in the type of scheduled surface
                    after the market has been loaded, all bets will stand.
                  </span>
                  <br />
                  <br />
                  <span>5. Periods of time</span>
                  <br />
                  <span>* </span>
                  <span>
                    Some markets have different rules and these are listed in
                    the Specific Sports Rules and/or the Market Information.
                    However, if not dealt with in the Specific Sports Rules or
                    the Market Information then the following shall apply.
                  </span>
                  <br />
                  <br />
                  <span>
                    * If the scheduled duration of an event is changed after the
                    market has been loaded but before the start of the event,
                    then all bets will be void.
                  </span>
                  <br />
                  <br />
                  <span>
                    * Some markets refer to the length of time until an
                    occurrence in the event (e.g. time of first goal). If an
                    event happens in stoppage or injury time after any regular
                    time period then it will be deemed to have occurred at the
                    end of the regular time period. For example, if a goal is
                    scored in first half stoppage-time in a soccer match it will
                    be deemed to have occurred in 45 minutes.
                  </span>
                  <br />
                  <br />
                  <span>
                    * All bets apply to the relevant full 'regular time' period
                    including stoppage time. Any extra-time and/or penalty
                    shoot-out is not included.
                  </span>
                  <br />
                  <br />
                  <span>
                    * References within these Rules and Regulations to a
                    particular number of 'days' shall mean the end of the day
                    local time after the expiry of the specified number of days.
                    For example, if a soccer match is scheduled for the 1st of
                    December, then the rule that allows the match to be
                    completed within three days after the scheduled completion
                    date (see Paragraph 3 above) would mean that the deadline
                    for completion of that match would be 23.59:59 on the 4th of
                    December.
                  </span>
                  <br />
                  <br />
                  <span>6. Match bets</span>
                  <br />
                  <span>* </span>
                  <span>
                    Some markets have different rules and these are listed in
                    the Specific Sports Rules and/or the Market Information.
                    However, if not dealt with in the Specific Sports Rules or
                    the Market Information then the following shall apply.
                  </span>
                  <br />
                  <br />
                  <span>
                    * 'Match Bets' for one-off events are determined by the
                    competitor or team with the best score, time or finishing
                    position in the event. If none of the competitors or teams
                    involved in the match bet complete the event or register a
                    score, time or finishing position then bets are void unless
                    specified otherwise in the Specific Sports Rules and/or the
                    Market Information. Any competitor or team not completing an
                    event or registering a score, time or finishing position
                    having taken part in the match bet event will be settled as
                    a loser providing at least one other team or competitor
                    completes that event or registers a score, time or finishing
                    position.
                  </span>
                  <br />
                  <br />
                  <span>
                    * 'Match Bets' for progress in a competition or event with
                    multiple heats or rounds are determined by the competitor or
                    team which qualifies to the furthest round (whether it takes
                    part in the further round or not) or with the best score,
                    time or finishing position in the final or same heat of that
                    competition or event. If the relevant competitors or teams
                    fail to qualify in the same round of the competition but in
                    different heats then dead-heat rules will apply,
                    irrespective of the finishing positions in their respective
                    heats. Markets will be part-settled after the end of each
                    round and any subsequent disqualifications, penalties or
                    amendments to results or qualifications will not have any
                    effect on the market. Where one or more of the competitors
                    or teams are disqualified, for the purposes of settlement,
                    the disqualified competitor or team will be deemed to have
                    progressed further in the competition or event than all
                    those eliminated from the competition or event prior to the
                    disqualification, and will be deemed to have finished last
                    (or joint last if there is more than one disqualification)
                    of those still competing in the competition or event.
                    Disqualification will be considered to have taken place at
                    the time of the competitor's or team's removal from the
                    competition or event by the relevant governing body, rather
                    than at the time of the event which caused disqualification.
                  </span>
                  <br />
                  <br />
                  <span>
                    * If one of the competitors or teams does not take any part
                    in the event, then all relevant match bets will be void.
                  </span>
                  <br />
                  <br />
                  <span>
                    * If an event or tournament is abandoned or reduced in
                    duration such that any competitor or team fails to complete
                    the match bet, event or tournament for any reason other than
                    withdrawal or disqualification then all bets will be void
                    except for those on markets which have been unconditionally
                    determined.
                  </span>
                  <br />
                  <br />
                  <span>7. "To qualify" markets</span>
                  <br />
                  <span>* </span>
                  <span>
                    Some markets have different rules and these are listed in
                    the Specific Sports Rules and/or the Market Information.
                    However, if not dealt with in the Specific Sports Rules or
                    the Market Information then the following shall apply.
                  </span>
                  <br />
                  <br />
                  <span>
                    * Any 'to qualify' market (e.g. "to reach the final"
                    markets) will be determined by the competitor or team that
                    qualifies under the terms set out in Market Information,
                    whether or not they take part in the next round or event for
                    which they have qualified. Markets will be settled after the
                    qualifying stage and any subsequent disqualification or
                    amendment to the result will not count.
                  </span>
                  <br />
                  <br />
                  <span>8. Dead heats</span>
                  <br />
                  <span>*</span>
                  <span> </span>
                  <span>
                    Unless stated otherwise in the Specific Sports Rules and/or
                    the Market Information the Dead Heat Rule applies to bets on
                    a market where there are more winners than expected (as set
                    out in the Market Information).
                  </span>
                  <br />
                  <br />
                  <span>
                    * For each bet matched on a relevant winning selection, the
                    stake money is first reduced in proportion by multiplying it
                    by the sum of the number of winners expected (as set out in
                    the Market Information), divided by the number of actual
                    winners (i.e. stake multiplied by (number of winners
                    expected/number of actual winners)). The winnings are then
                    paid to the successful backers on this 'reduced stake'
                    (reduced stake multiplied by traded price) and the remaining
                    stake money is paid to the appropriate layers.
                  </span>
                  <br />
                  <br />
                  <span>
                    * For example, assume there is a dead heat for first place
                    between three horses. 'Client A' has backed one of the
                    winners for a stake of 300 at the traded price of 4.0 and
                    'Client B' has taken the other side of this bet. When the
                    event is settled, the stake (300) is multiplied by 1/3 (i.e.
                    the number of expected winners (1) divided by the number of
                    actual winners (3)) to calculate the reduced stake (100) and
                    the remainder given to the layer (200). The backer then
                    receives the traded price matched (4.0) multiplied by the
                    reduced stake (4 x 100 = 400). In this example, Client A's
                    net winnings are 100 (400 payout minus the original 300
                    stake), and Client B's net losses are 100. Alternatively,
                    this can be viewed as the full amount paid to the traded
                    price divided by the number of dead-heaters. In the above
                    example, this would be 300 at the traded price of 4.0 (1200)
                    divided by 3; making 400 payouts and 100 net winnings.
                  </span>
                  <br />
                  <br />
                  <span>
                    * By way of another example, assume there is an outright
                    winner in a golf tournament but 7 players tie for 2nd place.
                    In the "top 5 finish" market, after settling on the outright
                    winner in the top 5 market there would be 4 others
                    designated winner’s places available. 'Client A' has backed
                    one of the winners for 300 at the traded price of 4.0 and
                    'Client B' has taken the other side of this bet. When the
                    event is settled, the stake (300) is multiplied by 4/7 (i.e.
                    the number of expected winners (4) divided by the number of
                    actual winners (7)) to calculate the reduced stake (171.43)
                    and the remainder given to the layer (128.57). The backer
                    then receives the traded price matched (4.0) multiplied by
                    the reduced stake (4 x 171.43 = 685.72). In this example,
                    Client A's net winnings are 385.72 (685.72 payout minus the
                    original 300 stake), and Client B's net losses are 385.72.
                  </span>
                  <br />
                  <br />
                  <span>
                    *In relation to customers whose betting counterparty, for
                    the purposes of this section of the Sportsbook Rules dealing
                    with dead heats, the terms 'Client A', 'Client B' and
                    'appropriate layers' should, where relevant, be read
                  </span>
                  <br />
                  <br />
                  <span>9. Sportsbook Multiples</span>
                  <br />
                  <span>
                    The Sportsbook Rules only apply to Sportsbook Multiples.
                  </span>
                  <br />
                  <br />
                  <span>
                    * Customers placing a multiple bet will be betting with each
                    other and will act as the counterparty to the bet.
                  </span>
                  <br />
                  <br />
                  <span>
                    * A multiple bet consists of a number of legs. A leg is
                    defined as one or more chosen selections in any individual
                    event market.
                  </span>
                  <br />
                  <br />
                  <span>
                    * It reserves the right in its sole discretion not to accept
                    certain multiple bets or to scale back stakes in certain
                    circumstances.
                  </span>
                  <br />
                  <br />
                  <span>
                    * All multiple bets placed are subject to the Sportsbook
                    Rules that apply to each individual sport that relates to
                    any leg of any multiple bet.
                  </span>
                  <br />
                  <br />
                  <span>
                    * The maximum payout limit for Sportsbook Multiples is
                    £1,000,000.
                  </span>
                  <br />
                  <br />
                  <span>
                    * Customers can place an Sportsbook Multiple bet using back,
                    or where available lay or a mixture of back and lay
                    selections. However, customers cannot have a combination of
                    back and lay selections in any one leg.
                  </span>
                  <br />
                  <br />
                  <span>
                    * If customers choose more than one selection in one leg the
                    odds for this leg will be "dutched" which means they will be
                    combined to reflect the chances of any of the selections
                    within the leg winning (if backed) or all of the selections
                    losing (if laid). If customers wish to place a
                    cross-multiple bet (i.e. more than one selection in any
                    event market but not using "dutched" prices) they will need
                    to enter each Sportsbook Multiple bet separately.
                  </span>
                  <br />
                  <br />
                  <span>
                    *Other than Sportsbook Multiples bets struck at Starting
                    Price ("BSP"), the odds available via the Sportsbook
                    Multiples product will be broadly based on the relevant
                    singles markets on the Sportsbook and any such winning
                    multiple bet will be subject to commission as set out in the
                    Charges' section of the website.
                  </span>
                  <br />
                  <br />
                  <span>
                    * Any winnings from Sportsbook Multiples bets struck at BSP
                    will not be subject to commission, but the odds returned on
                    each leg in such a multiple will be subject to a 5%
                    deduction from the BSP.
                  </span>
                  <br />
                  <br />
                  <span>
                    * A BSP each way Sportsbook Multiple bet is a bet for
                    selections in the multiple to win and a bet on the same
                    selections to place. For example, a £2 each way double
                    represents a £2 bet on both selections to win and a £2 bet
                    on both selections to be placed, with a total stake for the
                    bet of £4. The number of places for each event in each way
                    multiples bet are shown on the multiples win Market
                    Information and do not change. Should the number of runners
                    be equal to or less than the number of places available, the
                    relevant place leg of any multiples bet will be void
                  </span>
                  <br />
                  <br />
                  <span>
                    * The minimum total stake for any Sportsbook Multiple bet is
                    £2. For example, a 20p "Yankee" (11 bet combinations)
                    representing a total stake of £2.20 is permitted. However, a
                    1p "Heinz" (57 bet combinations) representing a total stake
                    of £0.57 or a £1 double (1 bet combination) representing a
                    total stake of £1 will not be permitted. For customers
                    betting in currencies other than English Sterling, the
                    minimum total stake which applies to an Sportsbook Multiple
                    bet will not necessarily be the equivalent of £2, though it
                    will be calculated as described in the example above.
                  </span>
                  <br />
                  <br />
                  <span>
                    * If, in its sole discretion, will determine the markets
                    that are available for Sportsbook Multiples. Events
                    available for Sportsbook Multiples will be those listed
                    within any individual Sportsbook Multiple group (e.g. UK
                    football fixtures for any given day). Not all markets will
                    be available via the Sportsbook Multiples product.
                  </span>
                  <br />
                  <br />
                  <span>
                    * With the exception of the rule directly below, if any
                    selection in any leg is a non-runner or otherwise void under
                    the Sportsbook Rules (e.g. an abandoned match) then all bets
                    on that individual leg will be void and the Sportsbook
                    Multiple bet shall be adjusted accordingly. For example, a
                    treble including one void leg will become a double. This
                    means that if customers have more than one selection in any
                    leg (i.e. in cases of 'ditching') and one of those
                    selections is a non-runner, the whole leg will be void. In
                    the event that voided legs mean that an individual bet
                    within a multiple becomes a single bet, then this single bet
                    will stand.
                  </span>
                  <br />
                  <br />
                  <span>
                    * Notwithstanding the rule directly above, for Sportsbook
                    Multiples bets struck at BSP, if customers have more than
                    one selection in any leg and one of those selections is a
                    non-runner the leg will stand.
                  </span>
                  <br />
                  <br />
                  <span>
                    * It reserves the right not to accept certain combinations
                    of Sportsbook Multiples, such as those including related
                    contingencies (i.e. where the outcome of one event is likely
                    to affect the odds on the outcome of another event). This
                    may happen automatically at the bet placement stage.
                    Alternatively, if such bet is taken in error, it may void
                    the individual bet combinations which include two or more of
                    the related contingency selections.
                  </span>
                  <br />
                  <br />
                  <span>
                    * It may offer special markets on related events from time
                    to time, including within its normal markets (i.e. outside
                    of the Sportsbook Multiples product), for example a market
                    on Chelsea to win the English domestic double (i.e.
                    Premiership and FA Cup).
                  </span>
                  <br />
                  <br />
                  <span>
                    * When placing any Sportsbook Multiple bet, the prices shown
                    only give an indicative guide as to the price available for
                    each leg and the overall multiple. Other than Sportsbook
                    Multiples bets struck at BSP, the price of each leg and the
                    overall multiple price that customers get will be fixed when
                    the multiple bet is actually placed and customers will then
                    be able to see these prices. For more details on this
                    customer should refer to the 'help' files.
                  </span>
                  <br />
                  <br />
                  <span>10. Rules for Starting Price</span>
                  <br />
                  <span>* </span>
                  <span>
                    Starting Price ('SP') is available on the Sportsbook.
                    Sportsbook SP bets (‘SP bets’) are therefore a type of
                    Sportsbook bet. The SP is calculated as, by balancing all SP
                    bets and other Sportsbook bets when the market is suspended
                    at the 'off' of the relevant event. The details of this
                    calculation are provided directly below.
                  </span>
                  <br />
                  <br />
                  <span>
                    * Please note that for all customers, an SP bet cannot be
                    cancelled once it has been placed.
                  </span>
                  <br />
                  <br />
                  <span>
                    * A bet at SP is a fixed odd bet, with the odds on each
                    selection being calculated and bets matched when the event
                    starts. The odds are calculated by matching SP backers and
                    other Sportsbook backers against SP layers and other
                    Sportsbook layers. The inclusion of other Sportsbook bets in
                    the SP reconciliation is necessary to ensure that: SP
                    backers get the benefit of unmatched Sportsbook offers to
                    lay if those offers could increase the SP; and SP layers get
                    the benefit of unmatched Sportsbook offers to back if those
                    offers could reduce the SP. Including unmatched other
                    Sportsbook in the SP reconciliation also ensures that the
                    bets of other Sportsbook backers and layers, which would
                    otherwise lapse, are matched where possible.
                  </span>
                  <br />
                  <br />
                  <span>
                    * The minimum liability for a bet placed at SP is £10 for a
                    lay bet and £2 for a back bet (or the currency equivalent in
                    each case).
                  </span>
                  <br />
                  <br />
                  <span>
                    * Example 1: on selection A there is £1,000 of backers'
                    stakes and £6,000 of layers' liabilities at SP and there are
                    £500 of unmatched other Sportsbook back bets available to
                    lay at an average of 5.0. If we ignored the Sportsbook
                    market in this case the SP would be 7.0. However, this would
                    leave other Sportsbook back bets that could also have been
                    matched at their requested price against SP layers,
                    unmatched. Therefore, the SP will be 5.0 and all SP backers
                    and SP layers will be matched at that price. The £500 of
                    Sportsbook backers' stakes will also be matched at their
                    requested price of 5.0 against the SP layers.
                  </span>
                  <br />
                  <br />
                  <span>
                    * Example 2: on selection B there are £831 of backers'
                    stakes and £4,428 of layers' liabilities at SP and the
                    following unmatched other Sportsbook lay bets, available to
                    back: £20 at 6.8, £31.13 at 6.6 and £100 at 6.4. In this
                    case the SP will be 6.68. This is calculated by including
                    the £20 available to back at 6.8 and the £31.13 available to
                    back at 6.6 and balancing those amounts against the SP
                    backers' stakes and SP layers' liabilities. The £100
                    available to back on the Sportsbook at 6.4 remains unmatched
                    as to include any of this amount would lead to an imbalance
                    between SP backers and SP layers.
                  </span>
                  <br />
                  <br />
                  <span>
                    * The SP is calculated to six decimal places for each
                    selection, though it may be displayed in the relevant market
                    view (or in any form/results data) to two decimal places,
                    rounded up or down as applicable. After reconciliation, the
                    full SP on each selection is available by clicking on the
                    relevant individual runner graph.
                  </span>
                  <br />
                  <br />
                  <span>
                    * If for whatever reason the site is unavailable when an
                    event starts or the SP cannot otherwise be reconciled at the
                    'off’, it will determine the SP using all available
                    information. For the avoidance of doubt this information
                    will not be limited to betting activity on the relevant
                    market(s). Also in these circumstances, a licensed betting
                    operator within the group may act as risk counterparty to SP
                    bets if necessary to ensure a fair SP. The personnel
                    involved in determining the SP in such circumstances will
                    have no undeclared personal or other interest in the SP in
                    question.
                  </span>
                  <br />
                  <br />
                  <span>
                    * If the SP reconciliation process is undertaken
                    prematurely, then it will endeavor to reverse the
                    reconciliation so that the SP is determined when the event
                    starts. There may however be circumstances in which this is
                    not possible, in which case the SP will be based on the
                    initial reconciliation.
                  </span>
                  <br />
                  <br />
                  <span>
                    * In cases where an SP reconciliation is reversed: SP bets
                    (including SP limit bets), 'At In-play: Take SP' bets and
                    'At In-play: Keep' bets will all revert to their status
                    before the reconciliation; and 'At In-play: Cancel' bets
                    will either remain cancelled if not matched as part of the
                    reconciliation process, or if matched as part of the
                    reconciliation process, will revert to their unmatched
                    status before the reconciliation.
                  </span>
                  <br />
                  <br />
                  <span>
                    * If the SP reconciliation process is undertaken later than
                    scheduled (i.e. after the event has started) and determines
                    that a material event has occurred (this will generally mean
                    that the event is not turned in-play), the SP will be
                    determined based solely on SP bets (and ‘At In-play: Take
                    SP’ bets which are unmatched when suspends the relevant
                    market), placed before the 'off'. This means that ‘At
                    In-play: Take SP’ bets matched after the off, will be made
                    void and not included in the reconciliation process. In
                    addition, SP bets placed after the 'off' will be voided.
                    However, if the SP reconciliation process is undertaken
                    later than scheduled but determines that no material event
                    has occurred, all bets will stand.
                  </span>
                  <br />
                  <br />
                  <span>
                    * If a SP 'each way' option is offered this will be
                    processed as two separate bets: a win bet at SP and a 'to be
                    placed' bet at SP.
                  </span>
                  <br />
                  <br />
                  <span>
                    * If for any reason unmatched bets are cancelled prior to a
                    market going in-play, then any unmatched bets that have been
                    selected to 'At In-play: Take SP' will be converted to SP
                    bets. Once those bets are converted, they cannot be
                    cancelled.
                  </span>
                  <br />
                  <br />
                  <span>➢ Party against whom you are betting at SP</span>
                  <br />
                  <br />
                  <span>
                    * When you place a bet at SP you are betting against other
                    customers. However, during the reconciliation of the SP, it
                    acts as counterparty in order to balance liabilities between
                    SP bets and other Sportsbook bets
                  </span>
                  <br />
                  <br />
                  <span>➢ Placing a SP bet</span>
                  <br />
                  <br />
                  <span>
                    * Selecting the 'SP' button in the market view gives
                    customers two different ways to request an SP bet. These are
                    as follows:
                  </span>
                  <br />
                  <br />
                  <span>
                    * The first way to request a bet at SP is by leaving the
                    'Set SP odds limit' box unticked at the top right of the bet
                    manager. For a back bet you are required to enter the stake
                    you wish to bet on the selection. For a lay bet, you are
                    required to enter the liability you are prepared to risk
                    against the selection – in other words the amount that you
                    are prepared to lose, should the selection win (or be placed
                    as applicable).
                  </span>
                  <br />
                  <br />
                  <span>
                    * The second way to request a bet at SP is to select the
                    'Set SP odds limit' option. Using this you can request a bet
                    at SP conditional upon minimum SP odds in the case of a back
                    bet, or maximum SP odds in the case of a lay bet. If SP is
                    shorter than the minimum price requested by a backer or is
                    longer than the maximum price requested by a layer, then the
                    relevant bet will lapse when the event starts. If SP is
                    longer than the minimum price requested by a backer or is
                    shorter than the maximum price requested by a layer, the bet
                    will be matched at the SP. Where an SP is equal to the price
                    limit specified by customers, those bets will be included
                    based on the time they were submitted, on a first come,
                    first served basis as is the existing convention for other
                    Sportsbook bets. This means that such bets may be unmatched
                    or partially matched.
                  </span>
                  <br />
                  <br />
                  <span>
                    * Please note that if a non-runner cannot be removed from
                    the relevant market until after the completion of the event,
                    the application to all bets matched at or before the "off"
                    (including SP bets) of any reduction factor, may mean that
                    the matched price for an SP back bet with an odds limit
                    requested, is adjusted to a price below the lower limit
                    requested. It may also mean that an SP lay bet request with
                    maximum odds requested, may not be matched even though the
                    odds on the selection, after any post-race adjustment for
                    the late non-runner, is below the maximum odds requested.
                  </span>
                  <br />
                  <br />
                  <span>
                    * If an SP bet with an odds limit is requested, the
                    minimum/maximum odds requested can be shortened in the case
                    of a back bet or lengthened in the case of a lay bet at any
                    time before the event starts. However, as mentioned above,
                    an SP bet request cannot actually be cancelled by a customer
                    once it has been placed. Details of the impact of
                    non-runners on the SP are provided below.
                  </span>
                  <br />
                  <br />
                  <span>➢Sportsbook bets which are unmatched at the 'off'</span>
                  <br />
                  <br />
                  <span>
                    * A normal Sportsbook bet is placed by choosing the odds of
                    your selection from the market view (as opposed to clicking
                    on the 'SP' of your selection). When such an Sportsbook bet
                    is fully or partially unmatched it can be adjusted and
                    cancelled in the normal course. Previously, unmatched bets
                    were automatically cancelled when a market was suspended at
                    the 'off' of the relevant event. You can now choose to
                    either have your unmatched Sportsbook bet convert to an SP
                    bet when the market suspends at the start of the event, or
                    to have the bet 'persist' when the event goes in-play (see
                    the 'keep' option below).
                  </span>
                  <br />
                  <br />
                  <span>
                    * In order to convert your unmatched Sportsbook bet to an SP
                    bet when the market suspends you should select the 'At
                    In-Play: Take SP' option in the bet manager. If there is a
                    non-runner in a win market with a reduction factor of at
                    least 2.5%, or a non-runner in a place market with a
                    reduction factor of at least 4%, it is policy to cancel
                    unmatched lay bets on all other runners in the market. In
                    the case of any such non-runner, instead of being cancelled
                    a lay bet for which the 'At In-Play: Take SP' option has
                    been selected, will automatically convert to an SP bet.
                    After this conversion, the bet cannot be cancelled.
                    Otherwise, unlike an SP bet, you can choose to cancel an
                    Sportsbook bet once it has been placed, even if you have
                    chosen for the bet to persist or to convert to an SP bet at
                    the start of the event.
                  </span>
                  <br />
                  <br />
                  <span>
                    * If you choose to convert an unmatched Sportsbook lay bet
                    to an SP bet, the liability of your Sportsbook lay bet will
                    be converted into a liability for the SP bet. Your liability
                    for that SP bet will never be more than the liability for
                    the Sportsbook bet you had specified. However, the amount
                    you can win on the SP lay bet may differ from the amount you
                    would have won had the Sportsbook bet been matched,
                    depending on the final SP.
                  </span>
                  <br />
                  <br />
                  <span>➢ Adjustments to SP bets for non-runners</span>
                  <br />
                  <br />
                  <span>
                    * SP back bets, will at no point amend either the stake or
                    the odds requested by a customer, despite any non-runners or
                    withdrawals. However, customers who have selected the SP
                    limit option can reduce the minimum SP odds they are
                    prepared to accept on a selection.
                  </span>
                  <br />
                  <br />
                  <span>
                    * For SP lay bets on win markets, it will reduce a
                    customer's liability based on the reduction factor(s) of any
                    non-runner(s) and the reduction factor of the runner on
                    which the customer's bet has been placed. This is to ensure
                    that the balance between the backers' stakes and the layers'
                    liability reflects the revised market after the runner has
                    been removed.
                  </span>
                  <br />
                  <br />
                  <span>
                    * Where an SP lay bet in a win market has a maximum odds
                    limit specified, this limit will be reduced by the reduction
                    factor of any non-runner, if the non-runner has a reduction
                    factor of at least 2.5%.
                  </span>
                  <br />
                  <br />
                  <span>
                    * For SP lay bets on place markets, it will still reduce a
                    customer's liability based on the reduction factor(s) of any
                    non-runner(s) but the calculation will be slightly
                    different, in line with the application of place market
                    reduction factors. The liability will be reduced by the
                    reduction factor of the removed runner. Where the lay bet on
                    a place market has a maximum odds limit specified, the
                    potential winnings on the bet (i.e. the odds – 1) will be
                    reduced by the reduction factor of the removed runner.
                  </span>
                  <br />
                  <br />
                  <span>
                    * Where an SP lay bet in a place market has a maximum odds
                    limit specified this limit will be reduced by the reduction
                    factor of any non-runner.
                  </span>
                  <br />
                  <br />
                  <span>
                    * SP lay bets will not be cancelled when there is a
                    non-runner.
                  </span>
                  <br />
                  <br />
                  <span>11. 'Keep' bets option</span>
                  <br />
                  <span>* </span>
                  <span>
                    For markets that are scheduled to be turned in-play at the
                    'off', a customer can request that an unmatched Sportsbook
                    bet should not be cancelled when the market is turned
                    in-play. This is done by selecting the 'At In-Play: Keep'
                    option in the bet manager (and confirming that request) and
                    means that the unmatched bet persists when other unmatched
                    bets are cancelled at the start of the event.
                  </span>
                  <br />
                  <br />
                  <span>
                    * When there is a late withdrawal, may not have time to
                    remove the non-runner from the market before turning it
                    in-play. In such cases if can determine that the late
                    withdrawal is a material runner (i.e. a selection with a
                    reduction factor of approx. 20% or greater in the win
                    market), it reserves the right to cancel ALL lay 'keep' bets
                    (in both the win and ‘to be placed’ markets) before turning
                    the market in-play. If it does not cancel lay 'keep' bets in
                    the case of a late withdrawal any such bets placed before
                    the off and matched in-play will remain at the original
                    selected price. This means that those lay 'keep' bets will
                    not be subject to any reduction factor which as a result of
                    the late withdrawal, will be applied after the completion of
                    the race to bets matched at or before the 'off'.
                  </span>
                  <br />
                  <br />
                  <span>
                    * Otherwise, in exceptional cases reserves the right to
                    cancel 'keep' bets to protect customers but, unless
                    stipulated in the market rules or the market information,
                    the general principle is that at no point will a 'keep' bet
                    be cancelled by unless it remains unmatched when the market
                    is closed (for the final time) at the end of the event.
                  </span>
                  <br />
                  <br />
                  <span>
                    * For the avoidance of doubt this means that (for example)
                    when a Material Event occurs in a soccer match and other
                    unmatched bets are cancelled before the market is reopened,
                    a keep bet will not be cancelled.
                  </span>
                  <br />
                  <br />
                  <span>12. Miscellaneous</span>
                  <br />
                  <span>*</span>
                  <span> </span>
                  <span>
                    All references to time periods in the Sportsbook Rules
                    relate to the time zone in which the event takes place. For
                    example, a reference to the start time of a football match,
                    relates to the local kick-off time.
                  </span>
                  <br />
                  <br />
                  <span>
                    * All information is done so in good faith. However, it
                    cannot accept liability for any errors or omissions in
                    respect of any information, such as the posting of prices,
                    runners, times, scores, results or general statistics.
                  </span>
                  <br />
                  <br />
                  <span>
                    * It reserves the right to correct any obvious errors and
                    shall take all reasonable steps to ensure markets are
                    administered with integrity and transparency.
                  </span>
                  <br />
                  <br />
                  <span>
                    * If an incorrect team or competitor name is displayed
                    (excluding minor spelling mistakes) or the incorrect number
                    of teams, competitors or outcomes is displayed in any
                    complete market or a market is otherwise loaded using
                    incorrect information (for example the application of an
                    incorrect exposure algorithm or a cross matching tool
                    utilising an incorrect algorithm) or includes any obvious
                    error such as the incorrect deployment of the cross matching
                    tool, then It reserves the right to suspend the market and
                    (providing it acts reasonably) to void all bets matched on
                    the market.
                  </span>
                  <br />
                  <br />
                  <span>
                    * Customers are responsible for ensuring that they satisfy
                    themselves that the selection on which they place a bet is
                    their intended selection. For example, in the case of a
                    competitor bearing the same name as another individual not
                    competing in the relevant event, the onus is on the customer
                    to ensure that they know which competitor It has loaded into
                    the relevant market and to ensure that they are placing
                    their bet on their chosen competitor.
                  </span>
                  <br />
                  <br />
                  <span>
                    * It reserves the right at any time in its sole and absolute
                    discretion to suspend an Sportsbook market.
                  </span>
                  <br />
                  <br />
                  <span>
                    * It may, in its sole and absolute discretion, decide to
                    suspend betting on a market at any time (even if such
                    suspension is earlier than anticipated by the Sportsbook
                    Rules). In the interests of maintaining integrity and
                    fairness in the markets, it may also void certain bets in a
                    market or void a whole market in its entirety.
                  </span>
                  <br />
                  <br />
                  <span>
                    * It reserves the right to amend the Sportsbook Rules at any
                    time.
                  </span>
                  <br />
                  <br />
                  <span>
                    * It reserves the right to cancel unmatched bets to protect
                    customers at any time.
                  </span>
                  <br />
                  <br />
                  <span>
                    * On the settlement of any market, amounts relating to
                  </span>
                  <br />
                  <span>&nbsp; &nbsp; * winnings/losses on bets; and</span>
                  <br />
                  <span>&nbsp; &nbsp; * commission charges</span>
                  <br />
                  <br />
                  <span>
                    * will be rounded up or down to the nearest two decimal
                    places (with the exception that rounding will always be down
                    (and never up) in respect of amounts relating to
                    winnings/losses in respect of BSP bets). By way of example,
                    £3.333, will be settled as £3.33, whereas £3.335, will be
                    settled as £3.34 (except that it will be settled as £3.33 in
                    respect of an amount relating to winnings/losses in respect
                    of BSP bets).
                  </span>
                  <br />
                  <br />
                  <span>
                    * The Sportsbook Rules have been prepared in various
                    languages other than English for reference only. In the
                    event of any differences between the English version and the
                    non-English version, the English version shall prevail.
                  </span>
                  <br />
                  <br />
                  <span>Part C - Specific sports rules</span>
                  <br />
                  <span>1. Cricket</span>
                  <br />
                  <br />
                  <span>&nbsp; ➢ General</span>
                  <br />
                  <br />
                  <span>
                    * If a ball is not bowled during a competition, series or
                    match then all bets will be void except for those on any
                    market that has been unconditionally determined (e.g. in the
                    'Completed Match' market).
                  </span>
                  <br />
                  <br />
                  <span>
                    * If a match is shortened by weather, all bets will be
                    settled according to the official result (including for
                    limited overs matches, the result determined by the
                    Duckworth Lewis method).
                  </span>
                  <br />
                  <br />
                  <span>
                    * In the event of a match being decided by a bowl-off or
                    toss of the coin, all bets will be void except for those on
                    markets that have been unconditionally determined.
                  </span>
                  <br />
                  <br />
                  <span>➢ Test matches</span>
                  <br />
                  <br />
                  <span>
                    * If a match starts but is later abandoned for any reason
                    other than weather (which may include but is not limited to:
                    dangerous or unplayable wicket or outfield; pitch vandalism;
                    strike or boycott; crowd protests/violence; stadium damage;
                    acts of terrorism; and acts of God), It reserves the right
                    to void all bets, except for those on markets that have been
                    unconditionally determined.
                  </span>
                  <br />
                  <br />
                  <span>
                    * If the match is not scheduled to be completed within five
                    days after the original scheduled completion date, then all
                    bets on markets for this event will be void, except for bets
                    on any markets that have been unconditionally determined.
                  </span>
                  <br />
                  <br />
                  <span>➢ Limited Over matches</span>
                  <br />
                  <br />
                  <span>
                    * If a match is declared "No Result'', bets will be void on
                    all markets for the event except for those markets which
                    have been unconditionally determined or where the minimum
                    number of overs have been bowled as laid out in the market
                    specific information.
                  </span>
                  <br />
                  <br />
                  <span>
                    * In the event of a new toss taking place on a scheduled
                    reserve day for a limited over match all bets that were
                    placed after 30 minutes before the original scheduled start
                    of play on the first day will be made void. This rule
                    relates to all markets except those that have been
                    unconditionally determined (e.g. in the win the toss and
                    toss combination markets).
                  </span>
                  <br />
                  <br />
                  <span>➢ Super Over rule</span>
                  <br />
                  <br />
                  <span>
                    * Which team will win this Super Over? This market will be
                    suspended on site and activated once the provider is aware a
                    Super Over is to be played. The market will be turned
                    in-play at the start of the Super Over. This market will not
                    be actively managed therefore it is the responsibility of
                    all customers to manage their positions. This market will be
                    settled based on the number of runs scored by each team in
                    the initial Super Over. For the avoidance of doubt, if
                    scores are tied at the completion of both innings in the
                    Super Over then the market will be settled as a Dead Heat
                    except in cases where more than one Super Over is played,
                    where it will be settled on the winner of the final over.
                    Any tie breaker that may be used to determine a winner
                    including but not limited to higher number of boundaries,
                    higher number of sixes, losing fewer wickets, coin toss etc.
                    do not count for the purposes of this market.
                  </span>
                  <br />
                  <br />
                  <span>2. Soccer</span>
                  <br />
                  <span>*</span>
                  <span> </span>
                  <span>
                    If it does not suspend a market on time for the occurrence
                    of a Material Event, it reserves the right to void bets
                    unfairly matched after the Material Event has occurred.
                    Voiding of these bets may take place during the event or
                    retrospectively once a game is completed.
                  </span>
                  <br />
                  <br />
                  <span>
                    * If a match has not started (or believes that a match will
                    not have started) by 23:59 (local time) on its scheduled
                    start date, then all bets will be void unless it has
                    knowledge that the match has been rescheduled to be played
                    within three days of its original start date.
                  </span>
                  <br />
                  <br />
                  <span>
                    * If a match starts but is later abandoned or postponed and
                    believes that the match will not have been completed by
                    23:59 (local time) on its scheduled start date, then all
                    markets, with the exception of any unconditionally
                    determined markets, will be void unless it has knowledge
                    that the match has been rescheduled to be played within
                    three days of its original start date. If it does have
                    knowledge that the game will be played within three days and
                    the game is played within three days, then all bets will
                    stand except if the match is restarted from the beginning.
                    If the match is restarted from the beginning then all bets
                    matched before the market went in-play will stand, but any
                    bets placed in-play will be void, except for any bets placed
                    in-play on markets which have been unconditionally
                    determined, which will stand.
                  </span>
                  <br />
                  <br />
                  <span>
                    * For Friendly matches, all bets apply to the full duration
                    of play according to the match officials, plus any stoppage
                    time. If a friendly match starts but is later abandoned or
                    postponed and is not completed (i.e. the full duration of
                    play according to match officials, plus any stoppage time)
                    within three days of the scheduled start date, all bets will
                    be void except for those on markets which have been
                    unconditionally determined. In the case of ambiguity over
                    the official result from match officials, the outcome will
                    be determined (acting reasonably) using information from
                    independent sources.
                  </span>
                  <br />
                  <br />
                  <span>
                    * If an official fixture lists different team details to
                    those listed (for example, the team name, reserves, age
                    group, gender, etc.), then all bets matched on the affected
                    markets will be void. In all other cases, bets will stand
                    (including instances where a team name is listed without
                    specifying the term 'XI' in the name). If an official
                    fixture is shown on the website under an incorrect
                    competition name, then it reserves the right to void all
                    bets matched on the affected markets.
                  </span>
                  <br />
                  <br />
                  <span>
                    * If a team is relegated from a league because, at the end
                    of a season, it has finished within the relegation positions
                    which are relevant to that league (i.e. usually any of the
                    bottom three league positions), bets on that team to be
                    relegated will be settled as winning bets. If a team is
                    otherwise disqualified, thrown out or removed from a league
                    (i.e. in circumstances other than those where it has
                    finished the season within the relevant relegation
                    positions): (i) if such team is disqualified, thrown out or
                    removed from the league before the relevant season has
                    started, all bets on the affected market will be void (and a
                    new market will subsequently be loaded) and (ii) if such
                    team is disqualified, thrown out or removed from the league
                    after the relevant season has started (or a determination is
                    made by the applicable governing body, during the season,
                    that the team will be thrown out or removed from the league
                    following the season’s conclusion), all bets on the affected
                    team will be void. For the avoidance of doubt, if a points
                    deduction is imposed on a team such that it finishes the
                    season within the relegation places which are relevant to
                    the applicable league, bets on that team to be relegated
                    will be settled as winning bets.
                  </span>
                  <br />
                  <br />
                  <span>
                    * The relevant season will be deemed to have started once
                    the first league game has been played. For the purposes of
                    this rule, markets relating to individual matches will not
                    be deemed to be "affected markets".
                  </span>
                  <br />
                  <br />
                  <span>
                    * 'Shirt numbers' bets will refer to the shirt number
                    allocated at the start of the match. 'Shirt numbers' bets
                    will include own-goal scorers. Any player whose shirt bears
                    no number will be allocated the number 12.
                  </span>
                  <br />
                  <br />
                  <span>
                    * For 'time of first goal' bets (i.e. "First Goal Odds"
                    markets), the first half is deemed to last 45 minutes,
                    regardless of stoppage time. Also for these markets, please
                    note that the "0 - 10 Minutes" selection covers the first 10
                    minutes of the match. In other words, it runs from 0:00
                    until just before the clock hits 10:00. The "11 – 20
                    Minutes" selection runs from 10:00 until just before the
                    clock hits 20:00. The same principle applies to each of the
                    other selections in this market.
                  </span>
                  <br />
                  <br />
                  <span>
                    * For 'top goalscorer' markets only the goals scored in the
                    league or competition stated in the Market Information
                    count. For example, if a player joins a club mid-season any
                    goals scored in a different league will not count, however
                    goals scored for a different club in the same league will
                    count. Own goals will not count.
                  </span>
                  <br />
                  <br />
                  <span>
                    * In markets which relate to the number of incidents to
                    occur, such as 'number of corners', these will be determined
                    on the basis of the number taken, rather than awarded.
                  </span>
                  <br />
                  <br />
                  <span>
                    * For markets that relate to the number of bookings given,
                    the number of corners taken, any goal scorer or the time of
                    a particular goal, the result will be determined (acting
                    reasonably) using information from independent sources. In
                    such cases, if any new information comes into the public
                    domain within 48 hours of settlement, then it shall (acting
                    reasonably) determine either: (i) whether the market should
                    be reinstated or resettled in light of this new information;
                    or (ii) to wait for further information before deciding
                    whether to reinstate or resettle the market. Except it has
                    announced that it is waiting for further information, any
                    information that comes into the public domain more than 48
                    hours after a market has been settled shall not be
                    considered (regardless of whether or not such information
                    may have led to a different result).
                  </span>
                  <br />
                  <br />
                  <span>3. Tennis</span>
                  <br />
                  <span>* </span>
                  <span>
                    If a player or pairing retires or is disqualified in any
                    match, the player or pairing progressing to the next round
                    (or winning the tournament in the case of a final) will be
                    deemed the winner. However, if less than one set has been
                    completed at the time of the retirement or disqualification
                    then all bets relating to that individual match will be
                    void.
                  </span>
                  <br />
                  <br />
                  <span>
                    * All bets relating to the number of occurrences of certain
                    events within a tournament will be void if the tournament is
                    reduced in length, postponed or cancelled, except for those
                    on markets which have been unconditionally determined.
                  </span>
                  <br />
                  <br />
                  <span>
                    * All bets will stand regardless of changes to scheduled
                    venues, including any changes to a different type of
                    surface.
                  </span>
                  <br />
                  <br />
                  <span>
                    * If the scheduled duration of a match is reduced or
                    increased in the number of games/sets required to win, all
                    bets will be void except for those on markets which have
                    been unconditionally determined. Please note that this does
                    not apply to ‘Match Odds’ or ‘Set Winner’ markets on Davis
                    Cup matches or ‘dead rubber’ matches that have been
                    shortened from five sets to three sets after the market has
                    been loaded, provided that the match has been shortened in
                    accordance with the competition’s rules.
                  </span>
                  <br />
                  <br />
                  <span>
                    * Where markets are offered on individual games or sets
                    within a match, a retirement or disqualification during a
                    game or set will render bets on that game or set market and
                    all individual game or set markets void except those on
                    markets which have been unconditionally determined.
                  </span>
                </b>
                <br />
                <br />
                <br />
                &nbsp;
              </p>
            </div>
          </div>

          <div
            _ngcontent-serverapp-c3368753927
            className="content-box ng-star-inserted"
          >
            <div _ngcontent-serverapp-c3368753927 className="title">
              {t("ResponsibleGaming")}
            </div>
            <div _ngcontent-serverapp-c3368753927>
              <h4 dir="ltr">
                <b>
                  <span>Responsible Gaming</span>
                </b>
              </h4>
              <p dir="ltr">
                <b>
                  <span>Gambling With Responsibility</span>
                  <br />
                  <br />
                  <span>
                    Please read this information carefully for your own benefit.
                  </span>
                  <br />
                  <br />
                  <a href="https://bajifair.live/">
                    <span>https://bajifair.live/</span>
                  </a>
                  <span>
                    {" "}
                    is operated by Aurora Holdings N.V.. having its office at
                    Abraham de Veerstraat 9, Curacao. Company Registration
                    number 157258.
                  </span>
                  <br />
                  <br />
                  <br />
                  <span>Interpretation</span>
                </b>
              </p>
              <p dir="ltr">
                <b>
                  <span>
                    The words of which the initial letter is capitalized have
                    meanings defined under the following conditions.
                  </span>
                  <br />
                  <br />
                  <span>
                    The following definitions shall have the same meaning
                    regardless of whether they appear in singular or in plural.
                  </span>
                  <br />
                  <br />
                  <br />
                  <span>Definitions</span>
                </b>
              </p>
              <p dir="ltr">
                <b>
                  <span>For the purposes of these Terms and Conditions:</span>
                  <br />
                  <br />
                  <span>* </span>
                  <span>Account </span>
                  <span>
                    means a unique account created for You to access our Service
                    or parts of our Service.
                  </span>
                  <br />
                  <br />
                  <span>* </span>
                  <span>Company </span>
                  <span>
                    (referred to as either "the Company", "We", "Us" or "Our" in
                    this Agreement) refers to Aurora Holdings N.V.
                  </span>
                  <br />
                  <br />
                  <span>* </span>
                  <span>Service </span>
                  <span>refers to the Website.</span>
                  <br />
                  <br />
                  <span>* </span>
                  <span>Website </span>
                  <span>refers to</span>
                  <a href="https://bajifair.live/">
                    <span> https://bajifair.live/</span>
                  </a>
                  <br />
                  <br />
                  <span>* You </span>
                  <span>
                    mean the individual accessing or using the Service, or the
                    company, or other legal entity on behalf of which such
                    individual is accessing or using the Service, as applicable.
                  </span>
                  <br />
                  <br />
                  <br />
                  <span>Responsible Gambling and Self Exclusion</span>
                </b>
              </p>
              <p dir="ltr">
                <b>
                  <span>
                    Gambling means for the majority of our Users, entertainment,
                    fun and excitement. But we also know that for some of our
                    Users gambling has negative side effects. In the medical
                    science is pathologic gambling since many years as serious
                    sickness recognised.
                  </span>
                  <br />
                  <br />
                  <span>
                    Since our first day we have thought about this problem and
                    try our best to help. Under “Responsible Gambling” We
                    understand multiple steps of measures, with which a gambling
                    provider can help to lower the possibility of negative side
                    effects appearing. -In case they already appear we also try
                    to take active steps against them.
                  </span>
                </b>
              </p>
              <p dir="ltr">
                <b>
                  <span>
                    The most important instrument against negative side effects
                    from gambling is knowledge and education about the risks of
                    gambling to support our Users self-control in order to make
                    sure they do not suffer from negative side effects.
                  </span>
                  <br />
                  <br />
                  <br />
                  <span>Information and contact</span>
                </b>
              </p>
              <p dir="ltr">
                <b>
                  <span>
                    Our customer support team will help you via email at all
                    time without any additional costs for you:
                  </span>
                  <br />
                  <br />
                  <span>* email: </span>
                  <span>support.bd@bajifair.live</span>
                </b>
              </p>
              <p dir="ltr">
                <b>
                  <span>
                    Our customer support team will of course not give out any
                    information about You without Your consent to anyone else
                  </span>
                </b>
              </p>
              <p dir="ltr">
                <b>
                  <span>
                    In addition you also can take a self-test, if You are
                    already gambling addicted at:
                  </span>
                  <a href="https://www.begambleaware.org/gambling-problems/do-i-have-a-gambling-problem/">
                    <span>
                      {" "}
                      https://www.begambleaware.org/gambling-problems/do-i-have-a-gambling-problem/
                    </span>
                  </a>
                  <br />
                  <br />
                  <span>
                    And you can also find additional information about gambling
                    addictions at:
                  </span>
                  <a href="https://www.begambleaware.org/safer-gambling/">
                    <span> https://www.begambleaware.org/safer-gambling/</span>
                  </a>
                  <br />
                  <br />
                  <br />
                  <span>Helpful hints for responsible gambling at</span>
                  <a href="https://bajifair.live//">
                    <span> https://bajifair.live/</span>
                  </a>
                </b>
              </p>
              <p dir="ltr">
                <b>
                  <span>
                    We recommend you think about the following hints, before
                    gambling in order to insure gambling stays fun for You and
                    without any negative side effects:
                  </span>
                </b>
              </p>
              <p dir="ltr">
                <b>
                  <span>* </span>
                  <span>Set yourself a deposit limit</span>
                </b>
              </p>
              <p dir="ltr">
                <b>
                  <span>
                    Before you start gambling, be sure to assess the amount you
                    can afford based on your financial situation and make sure
                    the amount you bet is only for entertainment and recreation.
                  </span>
                  <br />
                  <br />
                  <span>* </span>
                  <span>Do not try to win back a loss at every cost</span>
                </b>
              </p>
              <p dir="ltr">
                <b>
                  <span>
                    Try to not take huge risks to win back what You lost before
                    at any cost. Play for Entertainment and not to earn money.
                  </span>
                </b>
              </p>
              <p dir="ltr">
                <b>
                  <span>* </span>
                  <span>Set yourself a time limit</span>
                </b>
              </p>
              <p dir="ltr">
                <b>
                  <span>
                    Set yourself a time limit and do not break it. Keep in mind
                    gambling should stay in balance with your other hobbies and
                    not be Your only hobby.
                  </span>
                </b>
              </p>
              <p dir="ltr">
                <b>
                  <span>* </span>
                  <span>Play smart</span>
                </b>
              </p>
              <p dir="ltr">
                <b>
                  <span>
                    It is smarter to not play when You are extremely stressed,
                    depressed or under too much pressure. Also do not play when
                    you are under the influence of Medications, Drugs or
                    Alcohol.
                  </span>
                </b>
              </p>
              <p dir="ltr">
                <b>
                  <span>* </span>
                  <span>Take breaks</span>
                </b>
              </p>
              <p dir="ltr">
                <b>
                  <span>
                    When you find yourself tired or can no longer concentrate,
                    it’s time to take a break
                  </span>
                </b>
              </p>
              <p dir="ltr">
                <b>
                  <span>* </span>
                  <span>Only one account</span>
                </b>
              </p>
              <p dir="ltr">
                <b>
                  <span>
                    To make it easier to understand how much time and money you
                    spend on gambling, we recommend that each player only create
                    one account.
                  </span>
                </b>
              </p>
              <p dir="ltr">
                <b>
                  <span>* </span>
                  <span>Minor Protection</span>
                </b>
              </p>
              <p dir="ltr">
                <b>
                  <span>
                    To use our services, you must be 18 years of age or older.
                    To prevent abuse, please keep your login information secure
                    to prevent minors around you from misusing your account.
                  </span>
                </b>
              </p>
              <p dir="ltr">
                <b>
                  <span>
                    We recommend the use of filtering applications to
                    effectively prevent minors, especially children, from being
                    exposed to content on the Internet that may be detrimental
                    to them
                  </span>
                </b>
              </p>
              <p dir="ltr">
                <b>
                  <span>
                    For parents we can recommend a list of internet filters, to
                    support them, from keeping their children from any content,
                    which was not suitable for them:
                  </span>
                  <br />
                  <br />
                  <a href="https://famisafe.wondershare.com/internet-filter/best-internet-filters.html">
                    <span>
                      https://famisafe.wondershare.com/internet-filter/best-internet-filters.html
                    </span>
                  </a>
                  <br />
                  <br />
                  <br />
                  <span>Self-Exclusion</span>
                </b>
              </p>
              <p dir="ltr">
                <b>
                  <span>
                    In case You are diagnosed with a gambling addiction or try
                    to stay away from gambling for a different reason, we want
                    to assist you to stay away from anything that doesn’t
                    benefit you. “Self-Exclusion” means that You exclude
                    yourself, out of Your own choice, from all gambling
                    services. This exclusion cannot be undone for a set amount
                    of time. If you wish to self-exclude yourself from gambling,
                    please message our customer support team and give them a
                    time span between 6 months and 5 years. They also will
                    explain to you all future steps and what is needed from you.
                  </span>
                </b>
              </p>
              <p dir="ltr">
                <b>
                  <span>* email: </span>
                  <span>support.bd@bajifair.live</span>
                  <br />
                  <br />
                  <span>
                    Please note that Self Exclusion is permanent for the set
                    time span, and for your protection, it cannot be revoked.
                  </span>
                  <br />
                  <br />
                  <span>
                    You are not allowed to open a new account during the
                    self-exclusion period, if you attempt to do so you are in
                    breach of our Terms of Service and we may permanently close
                    your existing account.
                  </span>
                </b>
                <br />
                <br />
                <br />
                &nbsp;
              </p>
            </div>
          </div>

          <div
            _ngcontent-serverapp-c3368753927
            className="content-box ng-star-inserted"
          >
            <div _ngcontent-serverapp-c3368753927 className="title">
              {t("KYC")}
            </div>
            <div _ngcontent-serverapp-c3368753927>
              <p dir="ltr">
                <b>
                  <span>KYC</span>
                </b>
              </p>
              <h4 dir="ltr">
                <b>
                  <span>KYC Policy of bajifair</span>
                </b>
              </h4>
              <p dir="ltr">
                <b>
                  <span>
                    When a user makes an aggregate lifetime total of deposits
                    exceeding EUR 2000 or requests a withdrawal of any amount on
                    the
                  </span>
                  <a href="https://bajifair.live//">
                    <span> </span>
                    <span>https://bajifair.live/</span>
                  </a>
                  <span>
                    {" "}
                    Platform, then it is compulsory for them to perform a full
                    KYC process.
                  </span>
                  <br />
                  <br />
                  <span>
                    During this process, the user will have to input some basic
                    details about themselves and then upload
                  </span>
                  <br />
                  <br />
                  <span>
                    1. A copy of Government Issued Photo ID (in some cases front
                    and back depending on the doc)
                  </span>
                  <br />
                  <br />
                  <span>2. A selfie of themselves holding the ID doc</span>
                  <br />
                  <br />
                  <span>3. A bank statement/Utility Bill</span>
                  <br />
                  <br />
                  <span>
                    Once uploaded, the user will get a “Temporarily Approved”
                    Status and the documents will now be on our side, and the
                    “KYC Team” will have 24hrs to go over them and email the
                    user about the outcome:
                  </span>
                  <br />
                  <br />
                  <span>*&nbsp; Approval</span>
                  <br />
                  <br />
                  <span>*&nbsp; Rejection</span>
                  <br />
                  <br />
                  <span>
                    *&nbsp; More information needed – No change in Status
                  </span>
                  <br />
                  <br />
                  <br />
                  <span>
                    When the user is on “Temporarily Approved” Status then
                  </span>
                  <br />
                  <br />
                  <span>* They can use the platform normally</span>
                  <br />
                  <br />
                  <span>
                    * They cannot deposit more than EUR 500 in aggregate total
                  </span>
                  <br />
                  <br />
                  <span>* They cannot complete any withdrawal.</span>
                  <br />
                  <br />
                  <br />
                  <span>1. Proof of ID</span>
                  <br />
                  <span>a. Signature Is there</span>
                  <br />
                  <br />
                  <span>
                    b. Country is not a Restricted Country: United States of
                    America and its territories, France and its territories,
                    Netherlands and its territories and countries that form the
                    Kingdom of Netherlands including Bonaire, Sint Eustatius,
                    Saba, Aruba, Curacao and Sint Maarten, Australia and its
                    territories, United Kingdom of Great Britain, Northern
                    Ireland, Spain, and Cyprus.
                  </span>
                  <br />
                  <br />
                  <span>c. Full Name matches client’s name</span>
                  <br />
                  <br />
                  <span>d. Document does not expire in the next 3 months</span>
                  <br />
                  <br />
                  <span>e. Owner is over 18 years of age</span>
                  <br />
                  <br />
                  <br />
                  <span>2. Proof of Residence</span>
                  <br />
                  <span>a. Bank Statement or Utility Bill</span>
                  <br />
                  <br />
                  <span>
                    b. Country is not a Restricted Country: United States of
                    America and its territories, France and its territories,
                    Netherlands and its territories and countries that form the
                    Kingdom of Netherlands including Bonaire, Sint Eustatius,
                    Saba, Aruba, Curacao and Sint Maarten, Australia and its
                    territories, United Kingdom of Great Britain, Northern
                    Ireland, Spain, and Cyprus.
                  </span>
                  <br />
                  <br />
                  <span>
                    c. Full Name matches client’s name and is same as in proof
                    of ID.
                  </span>
                  <br />
                  <br />
                  <span>d. Date of Issue: In the last 3 months</span>
                  <br />
                  <br />
                  <br />
                  <span>3. Selfie with ID</span>
                  <br />
                  <span>a. Holder is the same as in the ID document above</span>
                  <br />
                  <br />
                  <span>
                    b. The ID document is the same as in “1”. Make sure photo/ID
                    number is the same
                  </span>
                  <br />
                  <br />
                  <br />
                  <span>Notes on the “KYC Process”</span>
                  <br />
                  <span>1.</span>
                  <span> </span>
                  <span>
                    When the KYC process is unsuccessful then the reason is
                    documented and a support ticket is created in the system.
                    The ticket number along with an explanation is communicated
                    back to the user.
                  </span>
                  <br />
                  <br />
                  <span>
                    2. Once all proper documents are in our possession then the
                    account gets approved.
                  </span>
                  <br />
                  <br />
                  <br />
                  <span>“Other AML measures”</span>
                  <br />
                  <span>1.</span>
                  <span> </span>
                  <span>
                    If a user has not passed full KYC then they cannot make
                    additional deposits or withdrawals of any amount.
                  </span>
                  <br />
                  <br />
                  <span>
                    2. If a user has passed the KYC process successfully then
                  </span>
                </b>
              </p>
              <p dir="ltr">
                <b>
                  <span>
                    a. There is a deposit limit per transaction (max EUR 2,000)
                  </span>
                </b>
              </p>
              <p>&nbsp;</p>
              <p dir="ltr">
                <b>
                  <span>
                    b. Prior to any withdrawal there is a detailed algorithmic
                    and manual check on the activity and balance of the user to
                    see if the amount withdrawn is a result of proper activity
                    in the platform.
                  </span>
                  <br />
                  <br />
                  <span>
                    3. Under no circumstances may a user transfer funds directly
                    to another user.
                  </span>
                </b>
                <br />
                <br />
                <br />
                &nbsp;
              </p>
            </div>
          </div>
        </div>
      </div>
    </AccountLayout>
  );
};

export default Terms;
